import { Power0, TweenMax } from "gsap";
import { ClientState } from "../../../ClientState";

import { AddMouseDownListener, Color, CreateElement, Filter, Log, LogGroup, Point, Scale, SetStyles, Size, TranslatePointScreen2To1 } from "../../.././MyHelpers";
import { AudioManager, Track } from "../../../AudioManager";
import { ISystemContext } from "../../../Context/SystemContext";
import { GameSession } from "../../../GameSession";
import { FontResource } from "../../../ResourceManager/FontResource";
import { ImageResource } from "../../../ResourceManager/ImageResource";
import { Resourceful2 } from "../../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage } from "../../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../../ResourceManager/SpriteResource";
import { VideoResource2 } from "../../../ResourceManager/VideoResource";
import { RobotPlay } from "../../../RobotPlay";
import { Comet } from "../../../slot/Comet";
import { GenericPlusOne, PlusOneParams } from "../../../slot/FreegameBonus/GenericPlusOneAnimation";
import { IPlusOneFactory } from "../../../slot/FreegameBonus/IPlusOneFactory";
import { SpritePlusOneFactory } from "../../../slot/FreegameBonus/SpritePlusOneFactory";
import { MyCanvas, MyCanvasContext } from "../../../slot/MyCanvas";
import { ScatterRandomAward, ScatterRandomAwardCreateParams, ScatterRandomAwardPosition, ScatterRandomAwardResults } from "../../../slot/ScatterRandomAward/ScatterRandomAward";
import { SlotFeature } from "../../../slot/SlotFeature";
import { SlotGameMessages } from "../../../slot/SlotGameScreenMessages";
import { SlotSymbol } from "../../../slot/SlotSymbol";
import { ReelSymbolsToDisplay } from "../../../slot/SpinAnimation/ReelMapper";
import { SpinnableReelsParams } from "../../../slot/SpinAnimation/SpinnableReels";
import { S2_ReelMapper } from "../../../slot/SpinAnimation2/ReelMapper";
import { S2_ReelSetMapper } from "../../../slot/SpinAnimation2/ReelSetMapper";
import { S2_ReelSpinAnimation, S2_ReelSpinAnimParams } from "../../../slot/SpinAnimation2/ReelSpinAnimation";
import { S2_SpinAnimation } from "../../../slot/SpinAnimation2/SpinAnimation";
import { S2_IReelConfig, S2_ISpinnableReel, S2_SpinnableReels2 } from "../../../slot/SpinAnimation2/SpinnableReels";
import { CanvasSprite, CanvasSpriteSizing } from "../../../slot/Sprite/CanvasSprite";
import { GetStateNameCallback, StateChange, StateMachine } from "../../../slot/StateMachine";
import { ICanDrawSymbol, SpecificSymbolsAnimation, SymbolPositionToAnimate } from "../../../slot/SymbolsAnimation";
import { WinLineMarkers } from "../../../slot/WinLineMarkers";
import { GenericWinLinesAnimation, WinLinesAnimationParams, WinLinesTypeStyle } from "../../../slot/WinLines/GenericWinLinesAnimation";
import { IWinLinesFactory } from "../../../slot/WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../../../slot/WinLines/SquareWinLineFactory";
import { Translator } from "../../../Translator";
import { Panel } from "../../panel/panel";
import { BonusFinish, BonusPickElement, BonusPickReveal, BonusRevealRemaining, BonusTotalResult, IBonusStartConfig, SymbolPosition } from "../../SlotGame";
import { SlotBonus } from "../SlotBonus";
//import { BigSymbolFreegamesConfig } from "./BigSymbolFreegamesConfig";
import * as PIXI from 'pixi.js';
import { AwardOptionPosition, BigSymbolFreegamesCommonConfiguration, BigSymbolFreegamesEndAction, BigSymbolFreegamesSpinAction, BigSymbolSpinAndHoldEndAction, HistoryGame, ISimpleBonusAction, LineWin, ScatterRandomAwardConfiguration, ScatterRandomAwardResult, SimpleSlotGameState, SlotGameBet } from "../../../api";
import { ITimeout } from "../../../Context/Timeout";
import { PixiSpriteResource } from "../../../ResourceManager/PixiSpriteResource";
import { service } from "../../../services";
import { JackpotDisplayType, Presentation, Settings } from "../../../Settings";
import { ZIndex } from "../../../ZIndex";
import { ActionStats } from "../../IHistoyGame";
import { ChangeSpeedParams } from "../../SlotGameType1";
import { SpinTargetParams } from "../../SpinAnimation/SpinTargetParams";
import { S2_ReelSpinAnimationUpdateParams } from "../../SpinAnimation2/ReelSpinAnimation";
import { ITransition } from "../../Transition/ITransition";
import { ITransitionFactory, ITransitionParams } from "../../Transition/ITransitionFactory";
import { TransitionFactory } from "../../Transition/TransitionFactory";
import { MarkersInfoColors } from "../../WinLineInfoMarkers";
import { Bonus } from "../Bonus";
import { LoadingItem } from "../LoadingItem";
import { BigSymbolFreegamesContainer } from "./BigSymbolFreegamesContainer";
import { BigSymbolFreegamesMessages } from "./BigSymbolFreegamesMessages";
import { BigSymbolFreegamesBonusParams } from "./BigSymbolFreegamesParams";
import { BigSymbolFreegamesRunResult, PlusOneFeatureResult } from "./BigSymbolFreegamesRunResult";
import { BigSymbolFreegamesSession } from "./BigSymbolFreegamesSession";
import { BigSymbolFreegamesState } from "./BigSymbolFreegamesState";


// export interface BigSymbolFreegamesSession
// {
// 	basegameWinCents: number;
// 	totalWin: number;
// }

export enum BigSymbolFreegamesRecoverAction
{
	BigSymbolFreegameSpin = "BigSymbolFreegameSpin",
	BigSymbolFreegamesStart = "BigSymbolFreegamesStart"
}

export class BigSymbolFreegamesBonus extends SlotBonus implements Resourceful2, ICanDrawSymbol
{
	public override UpdateSpinSpeed(changeSpeedParams: ChangeSpeedParams) {
		throw new Error("Method not implemented.");
	}
	public override CreateTransitionPixi(app? : PIXI.Container): void {
		//throw new Error("Method not implemented.");
		this.transitionView.CreateTransitionPixi(app);
	}
	public override DestroyTransition(): void {
		//throw new Error("Method not implemented.");
		this.transitionView.DestroyTransitionPixi();
	}
	protected params: BigSymbolFreegamesBonusParams = null;
	protected config: BigSymbolFreegamesCommonConfiguration = null;
	protected view: HTMLElement = null;

	protected session: BigSymbolFreegamesSession = null;

	protected introMessageContainer: HTMLElement = null;
	//protected noPickintroMessageContainer: HTMLElement = null;
	//protected picksContainer: HTMLElement = null;
	//protected pickedMessageContainer: HTMLElement = null;
	protected reelsContainer: HTMLElement = null;
	protected finalMessageContainer: HTMLElement = null;

	protected containers: Map<BigSymbolFreegamesContainer, HTMLElement> = new Map<BigSymbolFreegamesContainer, HTMLElement>();

	//protected pickElem: HTMLElement = null;

	//protected containers: HTMLElement[] = [];

	//private logGroup: string = "BigSymbolFreegames";
	protected stateMachine: StateMachine<BigSymbolFreegamesState> = new StateMachine<BigSymbolFreegamesState>(BigSymbolFreegamesState.Idle, this.logGroup, (state: BigSymbolFreegamesState) => BigSymbolFreegamesState[state]);

	// REELS
	//protected spinnableReels: SpinnableReels = null;
	//protected spinAnimation: SpinAnimation = null;
	//protected reelSetMapper: ReelSetMapper = null;

	protected spinnableReels2: S2_SpinnableReels2 = null;
	protected spinAnimation2: S2_SpinAnimation = null;
	protected reelSetMapper2: S2_ReelSetMapper = null;

	// WIN LINES AND MARKERS
    protected winLinesAnimation: GenericWinLinesAnimation = null;
    protected winLinesFactory: IWinLinesFactory = new SquareWinLinesFactory();
    protected winLineMarkers: WinLineMarkers = null;

	// EXPANDING WILD FEATURE
	private features: Map<string, SlotFeature> = new Map<string, SlotFeature>();
	//private expandingWildsBulk: ExpandingWildsBulk = null;

	// +1 FREEGAME FEATURE
	//private plusOneAnim: BigSymbolFreegamesCoinBonus = null;

	protected scatterRandomAwardFeature: ScatterRandomAward = null;
	//protected holdingFeature: HoldingFeature = null;


	// spin delay, in millis
	//private autoSpinTimer: SingleShotTimer= new SingleShotTimer(() => this.AutoSpin(), 3000);
	//private autoSpinTimer: number = null;

	//
	protected lastSpinResult: BigSymbolFreegamesRunResult = null;
	protected scatterPositions: ScatterRandomAwardPosition[] = null;

	// win lines or colelct can be interrupted, 
	// when interrupted, start new spin right away 
	private spinInterrupted: boolean = false;

	protected winCreditAnimation: TweenMax = null;
	//protected winValues: any = { balance: 0, win: 0 };

	//protected symbolsAnimation: SymbolsAnimation = null;

	protected symbolsAnimation: SpecificSymbolsAnimation = null;
	protected bonusTriggerAnimation: SpecificSymbolsAnimation = null;

	//protected winMessageAnimation: WinMessageAnimation = null;
	//protected shakeAnimation: ShakeAnimation = null;
	//protected fountainAnimation: FountainAnimation = null;
	//protected bigWinCountAnimation: BigWinCountAnimation = null;

	protected panel: Panel;


	private lineMessage: HTMLElement = null;
	//private denomMessage: HTMLElement = null;

	//private transition: SceneTransition = null;

	protected audio: AudioManager = null;

	protected override parentresid: ResourceIdentifier = null;
	//protected resid: ResourceIdentifier = null;
	//protected screenProtocol: ScreenProtocol = null;
	//protected screenProtocolScope: ScreenProtocolScope = null;

	private lineMessageLeft: HTMLElement = null;
	private lineMessageRight: HTMLElement = null;

	//protected basegameWinCents: number = 0;

	protected clientState: ClientState = null;
	protected translator: Translator;

	protected robotPlay: RobotPlay;

	protected demoMessage: HTMLElement = null;

	//ADD VIDEO TRANSITION
	//protected transitionView:HTMLElement=null;
	//protected videotransition:HTMLVideoElement=null;

	//CREATE DIV TO TITLE 
	//protected titleSrpite:HTMLElement=null;
	//protected titleSprite: CanvasSprite = null;
	protected VoicePlay: boolean = true;

	protected spinnableReelsParams: SpinnableReelsParams = {};
	protected systemContext: ISystemContext = null;


	// protected wins: IWinMessage[] = [
	// 	{ name: "big", winMultiplier: 10, file: "big_win_966x185_half" },
	// 	{ name: "great", winMultiplier: 20, file: "great_win_1013x277_half" },
	// 	{ name: "huge", winMultiplier: 30, file: "huge_win_966x202_half" },
	// 	{ name: "awesome", winMultiplier: 40, file: "awesome_win_1119x213_half" },
	// 	{ name: "amazing", winMultiplier: 50, file: "amazing_win_1185x252_half" }
	// ];
	//protected grayScale: BlackAndWhiteSymbols = null;

	protected requiredSymbol: string = "SRA";


	// comet sprite to show
	protected comet: Comet = null;

	// index of the scatter, for which to show the comet
	protected currentScatterCometIndex: number = -1;

	protected loadingSequence: LoadingItem[] = [
		{Name: "Base",				Prepare: (r) => this.BasePrepare(r), 				Loaded: (r) => this.BaseLoaded(r)},
		{Name: "Containers",		Prepare: null, 										Loaded: (r) => this.SetMessageContainer(r)},
		{Name: "Reels",				Prepare: (r) => this.PrepareReels(r), 				Loaded: (r) => this.ReelsLoaded(r)},
		{Name: "Audio",				Prepare: (r) => this.AudioPrepare(r), 				Loaded: null},
		{Name: "Features", 			Prepare: (r) => this.FeaturesPrepare(r),			Loaded: (r) => this.FeaturesLoaded(r)},
		{Name: "BigWin",			Prepare: (r) => this.BigWinPrepare(r),				Loaded: (r) => this.BigWinLoaded(r)},
		{Name: "History",			Prepare: (r) => this.PrepareHistory(r),				Loaded: (r) => this.LoadedHistory(r)},
		{Name: "Comets",			Prepare: (r) => this.CometsPrepare(r),				Loaded: (r) => this.CometsLoaded(r)},
		{Name: "WinLines",			Prepare: (r) => this.PrepareWinLines(r),			Loaded: (r) => this.WinLinesLoaded(r)},
		//{Name: "Translation",		Prepare: null,										Loaded: (r) => this.TranslationsLoaded(r)},
		{Name: "Demo",				Prepare: null,										Loaded: (r) => this.DemoLoaded(r)},
		{Name: "Display",			Prepare: null,										Loaded: async (r) => this.HideAllContainers()},
		{Name: "TitleTransition",   Prepare: (r) => this.PrepareTransition(r),     		Loaded: (r) => this.LoadTransition(r)},
	];

	protected currentBonus: SlotBonus = null;
	protected nextWinBonus : boolean = false;

	//Create some canvas for button text dialog
	protected ButtonCanvas: MyCanvas[] = [];
	protected ButtonCountCtx: MyCanvasContext[] = [];
	protected fontHeight:number=Scale.fh(135);
	protected fontFamily: string;

	protected plusOneAnim: GenericPlusOne = null;
	protected plusOneFactory: IPlusOneFactory = new SpritePlusOneFactory();

	protected transitionView: ITransition = null;
	protected transitionViewFactory:ITransitionFactory= new TransitionFactory();

	//ADD TITLE IN TRANSITION
    protected TitleSpriteTransition: CanvasSprite = null;

	//Machine Lock 
	protected isLocked : boolean = false ;
	protected backgroundBigFreeGame: HTMLElement = null;


	protected BonusName(): string
	{
		return "BigSymbolFreegames";
	}

	protected autospinDelay: ITimeout;

	protected bonusList: Map<Bonus, SlotBonus> = new Map<Bonus, SlotBonus>();

	protected maxAdditionalFreegames : number;

	public constructor(gameName: string, params: BigSymbolFreegamesBonusParams, config: BigSymbolFreegamesCommonConfiguration) {
		super(gameName, params);

		this.params = params;
		// TODO keep config immutable, don't change!!
		this.config = JSON.parse(JSON.stringify(config));

		this.session = new BigSymbolFreegamesSession("Screen-1");

		this.parentresid = params.resid;
		//this.translator=translator;
		this.translator = params.translator;
		//this.resid = params.resid.Add("BigSymbolFreegames");

		//this.screenProtocol = params.screenProtocol;
		//this.screenProtocolScope = params.screenProtocolScope.Add("BigSymbolFreegames");

		this.panel = params.panel;

		this.audio = params.audio;
		this.clientState = params.clientState;
		this.systemContext = params.systemContext.CreateSubContext("BigSymbolFreegames");
		this.bonusList = params.bonusList;

		this.view = document.createElement("div");
		this.view.classList.add(this.resid.Scope());
		this.view.classList.add("BigSymbolFreegames");

		this.backgroundBigFreeGame = CreateElement("div",{
			classes:[this.resid.Scope(), "BackgroundBigFreeGame"],
			parentToAppend: this.view,
			style: {
				width: "100%",
				height: Scale.Hpx(1080*this.ScreenNumberConfiguration),
				position: "absolute",
				bottom: Scale.Ypx(0),
				//backgroundColor: "green",
				//zIndex: ZIndex.ElementsMenu.toString(),
			}
		});

		this.lineMessage = document.createElement("div");
		this.lineMessage.classList.add("line-message");

		// TODO move to some common place?
		if (params.slotGameMeta.Demo == true) {
			//demo message
			this.demoMessage = document.createElement("div");
			this.demoMessage.classList.add("demo-message");
			SetStyles(this.demoMessage,
				{
					position: "absolute",
					top: Scale.Ypx(86),
					right: Scale.Xpx(0),
					width:  Scale.Wpx(307),
					height: Scale.Hpx(86),
					fontSize: Scale.fhpx(99),
					letterSpacing: Scale.fhpx(5),
					fontFamily: "NotoSansDisplay-ExtraBold",
					color: "rgba(255, 0, 0, 1)",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					transform: "rotate(45deg)",
					zIndex:ZIndex.DemoMessage.toString(),
				})

			this.demoMessage.innerHTML = "DEMO";
		}

		//this.denomMessage = document.createElement("div");
		//this.denomMessage.classList.add("denom-message");

		this.maxAdditionalFreegames =  10;		

		this.stateMachine.SetCallback(BigSymbolFreegamesState.IntroMessage, StateChange.Begin, () => this.OnIntroMessageBegin());
		this.stateMachine.SetCallback(BigSymbolFreegamesState.IntroMessage, StateChange.End, () => this.OnIntroMessageEnd());

		// this.stateMachine.SetCallback(BigSymbolFreegamesState.Pick, StateChange.Begin, () => this.OnPickBegin());
		//this.stateMachine.SetCallback(BigSymbolFreegamesState.Pick, StateChange.End, () => this.OnPickEnd());

		// this.stateMachine.SetCallback(BigSymbolFreegamesState.PickedMessage, StateChange.Begin, () => this.OnPickedMessageBegin());
		// this.stateMachine.SetCallback(BigSymbolFreegamesState.PickedMessage, StateChange.End, () => this.OnPickedMessageEnd());
		//this.stateMachine.SetCallback(BigSymbolFreegamesState.Running, StateChange.Begin, () => this.OnRunningBegin());
	    void service.api?.registerOperation("MachineLock",   this.resid.ID(), (data) =>{this.isLocked= true;});
	    void service.api?.registerOperation("MachineUnlock", this.resid.ID(), () =>{this.isLocked= false;});
		this.stateMachine.SetCallback(BigSymbolFreegamesState.WaitFirstSpin, StateChange.Begin, () => this.OnWaitFirstSpinBegin());
		//this.stateMachine.SetCallback(BigSymbolFreegamesState.Spin, StateChange.End, () => this.OnSpinEnd());

		this.stateMachine.SetCallback(BigSymbolFreegamesState.Spin, StateChange.Begin, () => this.OnSpinBegin());
		this.stateMachine.SetCallback(BigSymbolFreegamesState.Spin, StateChange.End, () => this.OnSpinEnd());

		this.stateMachine.SetCallback(BigSymbolFreegamesState.Features, StateChange.Begin, () => this.OnFeaturesBegin());
		this.stateMachine.SetCallback(BigSymbolFreegamesState.Features, StateChange.End, () => this.OnFeaturesEnd());

		this.stateMachine.SetCallback(BigSymbolFreegamesState.BigWin, StateChange.Begin, () => this.OnBigWinBegin());
		//this.stateMachine.SetCallback(BigSymbolFreegamesState.BigWin, StateChange.End, () => this.OnBigWinEnd());

		this.stateMachine.SetCallback(BigSymbolFreegamesState.Win, StateChange.Begin, () => this.OnWinBegin());
		this.stateMachine.SetCallback(BigSymbolFreegamesState.Win, StateChange.End, () => this.OnWinEnd());

		this.stateMachine.SetCallback(BigSymbolFreegamesState.Collect, StateChange.Begin, () => this.OnCollectBegin());
		
		this.stateMachine.SetCallback(BigSymbolFreegamesState.Bonus, StateChange.Begin, () => this.OnBonusBegin());
		this.stateMachine.SetCallback(BigSymbolFreegamesState.Bonus, StateChange.End, () => this.OnBonusEnd());

		this.stateMachine.SetCallback(BigSymbolFreegamesState.SpinIdle, StateChange.Begin, () => this.OnSpinIdleBegin());
		this.stateMachine.SetCallback(BigSymbolFreegamesState.SpinIdle, StateChange.End, () => this.OnSpinIdleEnd());

		//this.stateMachine.SetCallback(BigSymbolFreegamesState.CometCollect, StateChange.Begin, () => this.OnCometCollectBegin());
		//this.stateMachine.SetCallback(BigSymbolFreegamesState.CometCollect, StateChange.End, () => this.OnCometCollectEnd());


		this.stateMachine.SetCallback(BigSymbolFreegamesState.FinalMessage, StateChange.Begin, () => this.OnFinalMessageBegin());
		this.stateMachine.SetCallback(BigSymbolFreegamesState.FinalMessage, StateChange.End, () => this.OnFinalMessageEnd());

		this.stateMachine.SetStateChangeCallback((oldState: BigSymbolFreegamesState, newState: BigSymbolFreegamesState, stateNameCallback: GetStateNameCallback<BigSymbolFreegamesState>) => {
			// Log.Debug(this.logGroup, "Changing state " + stateNameCallback(oldState) + " to " + stateNameCallback(newState));
		});

		this.robotPlay = params.robotPlay;

		this.autospinDelay = this.systemContext.TimingContext().CreateTimeout("autospinDelay", 1000, () => this.AutoSpin());
	}

	public StopAudio()
	{
		this.audio.Stop(this.resid.ScopedResourceName("background"));
	}

	protected basegameWinCents: number = 0;

	public async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		if (loadingStage != LoadingStage.Games)
		{
			return;
		}
		// Log.Debug(this.logGroup, "Preparing resources...");

		for (let item of this.loadingSequence)
		{
			await item.Prepare?.(resourceManager);
		};
		
		// this.transitionView = this.transitionViewFactory.Create(this.gameName, {
		// 	audio: this.params.audio,
		// 	basePath: this.params.commonPath,
		// 	logGroup: this.logGroup,
		// 	systemContext: this.systemContext
		// }, this.resid);

		// this.transitionView.PrepareResources(resourceManager);
		//LOAD VIDEO
		// resourceManager.AddGlobal(new VideoResource2({
        //     resid:  ResourceIdentifier.Global.Add(this.gameName),
        //     logGroup: LogGroup.Global.Add(this.gameName),
        //     src: Settings.ResourcesFolder + "multigame/slot/" + this.gameName + "/resources/video/presentation_3s",
        //     unloadOnHide: true
        // }));

		await this.PrepareTransition(resourceManager);
		//this.PrepareTransition(resourceManager);
		
	}

	// public PrepareTransition(resourceManager: ResourceManager) {
       	
	// 	let transitionResources : ITransitionParams =  { 
	// 		spriteResource:resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add("freegame3d")), 
	// 		videoResource :resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add(this.gameName)) ,
	// 		soundResource: this.audio.Track(this.resid.ScopedResourceName("freegame")),
	// 		audio: this.audio,
	// 		//basePath: this.params.commonPath,
	// 		logGroup: this.logGroup,
	// 		systemContext: this.systemContext,
	// 		gameName : this.gameName,
	// 		resid : this.resid,



	// 	};

	// 	this.transitionView = this.transitionViewFactory.Create(transitionResources);
	// 	this.transitionView.PrepareResources(resourceManager);

    // }

	public async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		if (loadingStage != LoadingStage.Games)
		{
			return;
		}

		for (let item of this.loadingSequence)
		{
			await item.Loaded?.(resourceManager);
		}

		// let transitionResources : ITransitionParams =  { 
		// 	spriteResource:resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add("freegame3d")), 
		// 	videoResource :resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add(this.gameName)) ,
		// 	soundResource: this.audio.Track(this.resid.ScopedResourceName("freegame")),
		// 	audio: this.audio,
		// 	//basePath: this.params.commonPath,
		// 	logGroup: this.logGroup,
		// 	systemContext: this.systemContext,
		// 	gameName : this.gameName,
		// 	resid : this.resid,



		// };

		// this.transitionView = this.transitionViewFactory.Create(transitionResources);
		// //this.transitionView.PrepareResources(resourceManager);

		// this.transitionView.ResourcesLoaded(resourceManager);
		// this.view.appendChild(this.transitionView.View());
	}


	//PREPARE TITLE FOR TRANSITION 
	public async PrepareTransition(resourceManager: IWriteOnlyResourceManager)
	{
		if (Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay) {
			this.audio.AddTrack(new Track(this.params.commonPath + "resources/BigSymbolFreegames/resources/tracks/freegame" + Settings.audioFormat, this.resid.ScopedResourceName("freegame")));
			this.audio.AddTrack(new Track(this.params.commonPath + "resources/BigSymbolFreegames/resources/tracks/transitionLight" + Settings.audioFormat, this.resid.ScopedResourceName("transitionLight")));		
			resourceManager.AddGlobal(new SpriteResource(this.params.commonPath + "resources/BigSymbolFreegames/resources/freegame3d", ResourceIdentifier.Global.Add("TitleTransition").Add("Bigfreegame3d"), true, LogGroup.Global.Add("TitleTransition").Add("Bigfreegame3d"), true));
			let pathVideo = this.params.commonPath + "resources/BigSymbolFreegames/resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/Background_" + this.ScreenNumberConfiguration + "S";
			//Overwrite this video path because for this jackpots need different 
			if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotOrtiz || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStep || Settings.JackpotDisplayType == JackpotDisplayType.DragonJackpot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotRappidFrames ) {
				pathVideo = Settings.ResourcesFolder + "multigame/slot/" + this.gameName + "/resources/video/presentation_" + this.ScreenNumberConfiguration + "s";
			}

			if (Settings.PresentationType == Presentation.VideoGameSprite) {
				resourceManager.AddGlobal(new VideoResource2({
					resid: ResourceIdentifier.Global.Add(this.gameName +"-"+this.bonusName+"-Transition-"+this.ScreenNumberConfiguration),
					logGroup: LogGroup.Global.Add(this.gameName +"-"+this.bonusName+"-Transition-"+this.ScreenNumberConfiguration),
					src: pathVideo,
					unloadOnHide: true
				}));
			}
			if (Settings.PresentationType == Presentation.VideoCommonNoSprite) {
				pathVideo = this.params.commonPath + "resources/BigSymbolFreegames/resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/BackgroundVideoSprite_" + this.ScreenNumberConfiguration + "S";
				resourceManager.AddGlobal(new VideoResource2({
					resid: ResourceIdentifier.Global.Add(this.gameName +"-"+this.bonusName+"-Transition-"+this.ScreenNumberConfiguration),
					logGroup: LogGroup.Global.Add(this.gameName +"-"+this.bonusName+"-Transition-"+this.ScreenNumberConfiguration),
					src: pathVideo,
					unloadOnHide: true
				}));
			}
			
			else if (Settings.PresentationType == Presentation.Image) {
				let pathImgTransition = this.params.commonPath + "resources/BigSymbolFreegames/resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/BackgroundTransition_" + this.ScreenNumberConfiguration + "S.png";
				if(Settings.JackpotDisplayType == JackpotDisplayType.DiamondPot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotOrtiz || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStep){
					pathImgTransition = `${this.params.gamePath}resources/BackgroundTransition_${this.ScreenNumberConfiguration}S.png`;
				}
				resourceManager.AddGlobal(new ImageResource(pathImgTransition,
				ResourceIdentifier.Global.Add(this.gameName +"-"+this.bonusName+"-BackgroundTransition-"+this.ScreenNumberConfiguration).Scope()));
				
			}
			else if (Settings.PresentationType == Presentation.VideoCommonClassic) {
				pathVideo = this.params.commonPath + "resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/BackgroundCommonVideo_" + this.ScreenNumberConfiguration + "S";
				resourceManager.AddGlobal(new VideoResource2({
					resid: ResourceIdentifier.Global.Add(this.bonusName+"-Transition-"+this.ScreenNumberConfiguration),
					logGroup: LogGroup.Global.Add(this.bonusName+"-Transition-"+this.ScreenNumberConfiguration),
					src: pathVideo,
					unloadOnHide: true
				}));
			}
			else if (Settings.PresentationType == Presentation.VideoParticleTransitionMatterJS) {
				resourceManager.Add(new PixiSpriteResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/symbolFillingPotPartitle-Transition`, this.resid.Add("Partitle-Transition").Shared(), true, this.logGroup.Add("Partitle-Transition"), true));
				// resourceManager.AddGlobal(new JSONResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/partitleTransitionBoundingBox.json`,
				// ResourceIdentifier.Global.Add(this.gameName + "-" +this.bonusName + "-partitleTransitionBoundingBox").Shared().CSSScope(),true));
			}
			else if (Settings.PresentationType == Presentation.VideoParticleTransitionFadeInFadeOut) {
				resourceManager.Add(new PixiSpriteResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/symbolFillingPotPartitle-Transition`, this.resid.Add("Partitle-Transition").Shared(), true, this.logGroup.Add("Partitle-Transition"), true));
				// resourceManager.AddGlobal(new JSONResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/partitleTransitionBoundingBox.json`,
				// ResourceIdentifier.Global.Add(this.gameName + "-" +this.bonusName + "-partitleTransitionBoundingBox").Shared().CSSScope(),true));
			}
		}
	}
	//LOAD TITLE FOR TRANSITION 
	public async LoadTransition(resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		if (Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay) {
			let transitionResources: ITransitionParams = null;
			if (Settings.PresentationType == Presentation.VideoGameSprite) {
				transitionResources = {
					spriteResource: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add("Bigfreegame3d")),
					videoResource: resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add(this.gameName +"-"+this.bonusName+"-Transition-"+this.ScreenNumberConfiguration)),
					soundResource: this.audio.Track(this.resid.ScopedResourceName("freegame")),
					audio: this.audio,
					//basePath: this.params.commonPath,
					logGroup: this.logGroup,
					systemContext: this.systemContext,
					gameName: this.gameName,
					resid: this.resid.Add(this.gameName +"-"+this.bonusName+"-Transition-"+this.ScreenNumberConfiguration),
					imgResource: null,
					nameResource : this.gameName +"-"+this.bonusName+"-Transition-"+this.ScreenNumberConfiguration,
					fadeOut : true,
					particlesSprite: null,
					//boundingBox: null,
					transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
				};
			}
			else if (Settings.PresentationType == Presentation.Image) {
				transitionResources = {
					spriteResource: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add("Bigfreegame3d")),
					videoResource: null,
					soundResource: this.audio.Track(this.resid.ScopedResourceName("freegame")),
					audio: this.audio,
					//basePath: this.params.commonPath,
					logGroup: this.logGroup,
					systemContext: this.systemContext,
					gameName: this.gameName,
					resid: this.resid,
					imgResource: resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add(this.gameName  +"-"+this.bonusName+"-BackgroundTransition-" + this.ScreenNumberConfiguration)),
					nameResource : null,
					fadeOut : true,
					particlesSprite: null,
					//boundingBox: null,
					transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,


				};
			}
			else if (Settings.PresentationType == Presentation.VideoCommonNoSprite) {
				transitionResources = {
				   spriteResource: null,
				   videoResource: resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add(this.gameName +"-"+this.bonusName+"-Transition-"+this.ScreenNumberConfiguration)),
				   soundResource: this.audio.Track(this.resid.ScopedResourceName("freegame")),
				   audio: this.audio,
				   //basePath: this.params.commonpath,
				   logGroup: this.logGroup,
				   systemContext: this.systemContext,
				   gameName: this.gameName,
				   resid: this.resid,
				   imgResource: null,
				   nameResource : this.gameName +"-"+this.bonusName+"-Transition-"+this.ScreenNumberConfiguration,
					fadeOut: false,
					particlesSprite: null,
					//boundingBox: null 
					transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
			   };
			}
			else if (Settings.PresentationType == Presentation.VideoCommonClassic) {
				transitionResources = {
					spriteResource: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add("FreegameClassic")),
					videoResource: resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add(this.bonusName+"-Transition-"+this.ScreenNumberConfiguration)),
					soundResource: this.audio.Track(this.resid.ScopedResourceName("freegame")),
					audio: this.audio,
					//basePath: this.params.commonPath,
					logGroup: this.logGroup,
					systemContext: this.systemContext,
					gameName: this.gameName,
					resid: this.resid.Add(this.bonusName+"-Transition-"+this.ScreenNumberConfiguration),
					imgResource: null,
					nameResource : this.bonusName+"-Transition-"+this.ScreenNumberConfiguration,
					fadeOut : true,
					particlesSprite : null,
					//boundingBox : null,
					transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
				};
			}
			else if (Settings.PresentationType == Presentation.VideoParticleTransitionMatterJS) {
				//let jsonBoundingBox = (resourceManager.Get<JSONResource>(this.resid.Add(`Symbol-PartitleTransitionBoundingBox`).Shared().CSSScope()).json) as IMyBoundingBox;
				transitionResources = {
					spriteResource: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add("FreegameClassic")),
					videoResource: null,
					soundResource: this.audio.Track(this.resid.ScopedResourceName("VoiceJackpotType")),
					audio: this.audio,
					//basePath: this.params.commonPath,
					logGroup: this.logGroup,
					systemContext: this.systemContext,
					gameName: this.gameName,
					resid: this.resid.Add(this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
					imgResource: null,
					nameResource: this.bonusName + "-Transition-" + this.ScreenNumberConfiguration,
					fadeOut: true,
					particlesSprite : resourceManager.Get<PixiSpriteResource>(this.resid.Add(`Partitle-Transition`).Shared()).sprite,
					boundingBox : null,
					transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
				};
			}
			else if (Settings.PresentationType == Presentation.VideoParticleTransitionFadeInFadeOut) {
				//let jsonBoundingBox = (resourceManager.Get<JSONResource>(this.resid.Add(`Symbol-PartitleTransitionBoundingBox`).Shared().CSSScope()).json) as IMyBoundingBox;
				transitionResources = {
					spriteResource: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add("FreegameClassic")),
					videoResource: null,
					soundResource: this.audio.Track(this.resid.ScopedResourceName("VoiceJackpotType")),
					audio: this.audio,
					//basePath: this.params.commonPath,
					logGroup: this.logGroup,
					systemContext: this.systemContext,
					gameName: this.gameName,
					resid: this.resid.Add(this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
					imgResource: null,
					nameResource: this.bonusName + "-Transition-" + this.ScreenNumberConfiguration,
					fadeOut: true,
					particlesSprite : resourceManager.Get<PixiSpriteResource>(this.resid.Add(`Partitle-Transition`).Shared()).sprite,
					boundingBox : null,
					transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
				};
			}
			else {
				throw `${Settings.PresentationType} its not implemented change your setting PresentationType`
			}
			// this.transitionView = this.transitionViewFactory.Create(transitionResources);
			// await this.transitionView.ResourcesLoaded(resourceManager);
			// this.view.appendChild(this.transitionView.View());		
			
			this.transitionView = await this.systemContext.SharedTransitionContext().AddTransition(transitionResources);
			//this.transitionView.ResourcesLoaded(resourceManager);
			this.transitionView.onTransitionEnd = () => {
				this.OnTransitionEnded()
			}
			this.transitionView.onTransitionStart = () => {
				this.OnTransitionStarted()
			}
		}
	}	


	public async AudioPrepare(resourceManager: IWriteOnlyResourceManager)
	{
		this.audio.AddTrack(new Track(this.params.gamePath + "resources/BigSymbolFreegames/tracks/background" + Settings.audioFormat, this.resid.ScopedResourceName("background")));
		this.audio.AddTrack(new Track(this.params.gamePath + "resources/BigSymbolFreegames/tracks/backgroundend" + Settings.audioFormat, this.resid.ScopedResourceName("backgroundend")));
		this.audio.AddTrack(new Track(this.params.gamePath + "resources/BigSymbolFreegames/tracks/transition" + Settings.audioFormat, this.resid.ScopedResourceName("transitionaudio")));
		this.audio.AddTrack(new Track(this.params.gamePath + "resources/BigSymbolFreegames/tracks/pick" + Settings.audioFormat, this.resid.ScopedResourceName("pick")));
		this.audio.AddTrack(new Track(this.params.gamePath + "resources/BigSymbolFreegames/tracks/remaining" + Settings.audioFormat, this.resid.ScopedResourceName("remaining")));

		this.audio.AddTrack(new Track(this.params.gamePath + "resources/BigSymbolFreegames/tracks/bonustriggered" + Settings.audioFormat, this.resid.ScopedResourceName("triggered")));
		this.audio.AddTrack(new Track(this.params.commonPath + "resources/BigSymbolFreegames/resources/tracks/plusone" + Settings.audioFormat, this.resid.ScopedResourceName("plusone")));
		this.audio.AddTrack(new Track(this.params.commonPath + "resources/BigSymbolFreegames/resources/tracks/plusonemove" + Settings.audioFormat, this.resid.ScopedResourceName("plusonemove")));
		
		this.audio.AddTrack(new Track(this.params.commonPath + "resources/BigSymbolFreegames/resources/tracks/final" + Settings.audioFormat, this.resid.ScopedResourceName("final")));
		this.audio.AddTrack(new Track(this.params.gamePath + "resources/BigSymbolFreegames/tracks/freegameintro" + Settings.audioFormat, this.resid.ScopedResourceName("intro")));		
		this.audio.AddTrack(new Track(this.params.gamePath + "resources/BigSymbolFreegames/tracks/bigreelSpinStop" + Settings.audioFormat, this.resid.ScopedResourceName("bigreelSpinStop")));
	}

	/* protected MessagesLoaded(resourceManager: IReadOnlyResourceManager) 
	{

		this.introMessageContainer = this.view.querySelector(".introMessage");
		this.finalMessageContainer = this.view.querySelector(".finalMessage");



		this.containers.set(BigSymbolFreegamesContainer.IntroMessage, this.introMessageContainer);
		this.containers.set(BigSymbolFreegamesContainer.Reels, this.reelsContainer);
		this.containers.set(BigSymbolFreegamesContainer.FinalMessage, this.finalMessageContainer);
		

		// prepare intro message
		{
			let dialog: HTMLElement = this.introMessageContainer.querySelector(".dialog");
			//let dialog = this.introMessageContainer.querySelector(".dialog");
			dialog.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["dialog", "image"])).CssBackground();
			dialog.style.width = "1152px";
			dialog.style.height = "648px";

			let b: HTMLElement = dialog.querySelector<HTMLElement>(".startbut");
			b.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["button", "image"])).CssBackground();

			AddMouseDownListener(dialog.querySelector(".startbut"), () => {
				if (this.stateMachine.IsState(BigSymbolFreegamesState.IntroMessage)) {
					// Log.Debug(this.logGroup, "Intro message confirmed");
					this.stateMachine.ChangeState(BigSymbolFreegamesState.WaitFirstSpin);
				}
                else 
                {
					Log.Error(this.logGroup, "Can't confirm intro message, current state: " + BigSymbolFreegamesState[this.stateMachine.State()] + ", required state: " + BigSymbolFreegamesState[BigSymbolFreegamesState.IntroMessage]);
				}
			});
		}

		// prepare final message
		{
			let dialog: HTMLElement = this.finalMessageContainer.querySelector(".dialog");
			dialog.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["dialog", "image"])).CssBackground();
			dialog.style.width = "1152px";
			dialog.style.height = "648px";

			// this.View().querySelector("#headerend").appendChild(this.translator.Anchor(() => this.translator.t.endfree1));
			// this.View().querySelector("#startend1").appendChild(this.translator.Anchor(() => this.translator.t.endfree2));
			// this.View().querySelector("#startend2").appendChild(this.translator.Anchor(() => this.translator.t.endfree3));
			// this.View().querySelector("#startend3").appendChild(this.translator.Anchor(() => this.translator.t.endfree4));
			// this.View().querySelector("#fin").appendChild(this.translator.Anchor(() => this.translator.t.freegameend));

			let b: HTMLElement = dialog.querySelector<HTMLElement>(".startbut");
			b.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["button", "image"])).CssBackground();

			AddMouseDownListener(dialog.querySelector(".startbut"), () => {
				if (this.stateMachine.State() == BigSymbolFreegamesState.FinalMessage) {
					// Log.Debug(this.logGroup, "Final message confirmed");
					this.stateMachine.ChangeState(BigSymbolFreegamesState.Idle);


				}
				else {
					Log.Error(this.logGroup, "Can't confirm final message, current state: " + BigSymbolFreegamesState[this.stateMachine.State()] + ", required state: " + BigSymbolFreegamesState[BigSymbolFreegamesState.FinalMessage]);
				}
			});
		}

	} */
	protected ButtonCanvasText(resourceManager: IReadOnlyResourceManager) {
		for (let buttonText = 0; buttonText <= 1; buttonText++) {
			this.ButtonCanvas[buttonText] = new MyCanvas(new Size(Scale.W(454), Scale.H(300)), {
				style: {
					left: Scale.Xpx(8),
					top: Scale.Ypx(12),
					position: "relative",
					zIndex: "" + ZIndex.BonusWin,
				}
			});
		}
	}

	public SetTextCanvas(text:string,ButtonCanvas:MyCanvas)
	{
		ButtonCanvas.context.clearRect(0,0,ButtonCanvas.size.Width,ButtonCanvas.size.Height);
		//ButtonCanvas.context.font = "120px Verdana" /*+ this.font*/;
		ButtonCanvas.context.font = "bold " + this.fontHeight + "px " + this.resid.ScopedResourceName("bigwincount") ;

		let color:string="#F2E416";
		let color2:string="#F2BE22";
		let color3:string=" #C2760E";
		let color4:string="#F2BE22";	
		let color5:string="#F2E416";


		
		let gradient = ButtonCanvas.context.createLinearGradient(
            ButtonCanvas.size.Width /2, 
			ButtonCanvas.size.Height /2 - this.fontHeight/2, 
			ButtonCanvas.size.Width /2, 
			ButtonCanvas.size.Height /2 + this.fontHeight/2
		);

		
		gradient.addColorStop(0,color);	
		gradient.addColorStop(0.25,color2);			
		gradient.addColorStop(0.50,color3);	
		gradient.addColorStop(0.75,color4);		
		gradient.addColorStop(1,color5);
		
	
		ButtonCanvas.context.fillStyle = gradient;
	
		ButtonCanvas.context.textBaseline = "top";
		ButtonCanvas.context.textAlign="center";
		ButtonCanvas.context.lineJoin="round"; //Experiment with "bevel" & "round" for the effect you want!
		ButtonCanvas.context.miterLimit=2;
	
		ButtonCanvas.context.strokeStyle = "black";
		ButtonCanvas.context.lineWidth = Scale.fh(22) ;  
		ButtonCanvas.context.strokeText(text,(ButtonCanvas.size.Width/2),(ButtonCanvas.size.Height/4));
		
		ButtonCanvas.context.strokeStyle = "white";
		ButtonCanvas.context.lineWidth = Scale.fh(22)/4;
		ButtonCanvas.context.strokeText(text,(ButtonCanvas.size.Width/2),(ButtonCanvas.size.Height/4));
	
		ButtonCanvas.context.fillText(text,(ButtonCanvas.size.Width/2),(ButtonCanvas.size.Height/4));
		ButtonCanvas.RestoreContext();
	}

	protected async SetMessageContainer(resourceManager: IReadOnlyResourceManager): Promise<void>
	{

		//this.pickElem = this.view.querySelector(".pick-elem");
		await this.ButtonCanvasText(resourceManager);
		await this.PrepareIntroMessage(resourceManager);
		//this.PrepareNoPickIntroMessage(resourceManager);
		//this.PreparePicksContainer(resourceManager);
		//this.PreparePickMessageContainer(resourceManager);
		await this.PrepareFinalMessage(resourceManager);
		await this.PrepareReelsContainer(resourceManager);

		this.containers.set(BigSymbolFreegamesContainer.IntroMessage, this.introMessageContainer);
		this.containers.set(BigSymbolFreegamesContainer.Reels, this.reelsContainer);
		this.containers.set(BigSymbolFreegamesContainer.FinalMessage, this.finalMessageContainer);
	}

	protected PrepareIntroMessage(resourceManager: IReadOnlyResourceManager): void
	{
		this.introMessageContainer = CreateElement("div", {classes:["introMessageContainer"], parentToAppend: this.view, 
			style:
			{
				position:"absolute",
				top: Scale.Ypx(0),
				left: Scale.Xpx(0),
				width: Scale.Wpx(1920),
				height: Scale.Hpx(1080),
				zIndex:ZIndex.BonusCofirmMessage.toString()
			}
		});

		let messageContainer: HTMLElement = CreateElement("div", {classes:["MessageContainer"], parentToAppend: this.introMessageContainer,
			style:
			{
				width: Scale.Wpx(1920),
				height: Scale.Hpx(1080),
				display:"flex",
				justifyContent:"center",
				alignItems:"center",
				color:"yellow",
				//fontFamily: resourceManager.Get<FontResource>(this.resid.ScopedResourceName(["lines", "font"])).name,
			}
		});

		let dialog: HTMLElement = CreateElement("div",{classes:["dialog"],parentToAppend:messageContainer, 
			style:
				{
					position:"absolute",
					width: Scale.Wpx(1152),
					height: Scale.Hpx(648),
					backgroundSize: "contain",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
					backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["dialog", "image"])).CssBackground(),
				}
		});

		let bigSymbolFGMessageSpanish: HTMLElement = CreateElement("span",{
			style:
			{
				position: "absolute",
				width: Scale.Wpx(1152),
				height: Scale.Hpx(512),
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
				backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["intro", "spanish"])).CssBackground(),


			}
		});
		let bigSymbolFGMessageEnglish: HTMLElement = CreateElement("span",{
			style:
			{
				position: "absolute",
				width: Scale.Wpx(1152),
				height: Scale.Hpx(512),
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
				backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["intro", "english"])).CssBackground(),


			}
		});
		
		dialog.appendChild(this.translator.Anchor(()=> this.translator.t.BigFG(bigSymbolFGMessageSpanish.outerHTML, bigSymbolFGMessageEnglish.outerHTML)));
		
		let buttonContainer: HTMLElement = CreateElement("div", {classes:["buttonContainer"], parentToAppend:dialog, 
			style:
			{
				position:"absolute",
				bottom: Scale.Ypx(-129),
				width: Scale.Wpx(1152),
				height: Scale.Hpx(300),
				display: "flex",
				justifyContent: "center",
				alignItems: "center"
			}
		})
		
		let button: HTMLElement = CreateElement("div", {classes:["button"], parentToAppend:buttonContainer, 
			style:
			{
				width: Scale.Wpx(600),
				height: Scale.Hpx(300),
				fontSize: Scale.fhpx(100),
				display: "flex",
				justifyContent:"center",
				alignItems:"center",
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat:"no-repeat",
				backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["button", "image"])).CssBackground(),
			}
		});
		//button.appendChild(this.translator.Anchor(()=> this.translator.t.freegameStart));
		let text=this.translator.Anchor(()=> this.translator.t.freegameStart);
		this.SetTextCanvas(text.innerText,this.ButtonCanvas[0]);
	
		button.appendChild(this.ButtonCanvas[0].View());
	
		AddMouseDownListener(button, () => {
			if (this.stateMachine.State() == BigSymbolFreegamesState.IntroMessage) {
				// Log.Debug(this.logGroup, "Intro message confirmed");
				this.stateMachine.ChangeState(BigSymbolFreegamesState.WaitFirstSpin);
			}
			else {
				Log.Error(this.logGroup, "Can't confirm intro message, current state: " + BigSymbolFreegamesState[this.stateMachine.State()] + ", required state: " + BigSymbolFreegamesState[BigSymbolFreegamesState.IntroMessage]);
			}
		});


	}

	protected PrepareFinalMessage(resourceManager: IReadOnlyResourceManager): void
	{
		this.finalMessageContainer = CreateElement("div", {classes:["finalMessageContainer"], parentToAppend: this.view, 
			style:
			{
				position:"absolute",
				top: Scale.Ypx(0),
				left: Scale.Xpx(0),
				width: Scale.Wpx(1920),
				height: Scale.Hpx(1080),
				zIndex:ZIndex.BonusCofirmMessage.toString()
			}
		});

		let messageContainer: HTMLElement = CreateElement("div", {classes:["messageContainer"], parentToAppend: this.finalMessageContainer,
			style:
			{
				width: Scale.Wpx(1920),
				height: Scale.Hpx(1080),
				display:"flex",
				justifyContent:"center",
				alignItems:"center",
				color:"yellow",
				//fontFamily: resourceManager.Get<FontResource>(this.resid.ScopedResourceName(["lines", "font"])).name,

			}
		});

		let dialog: HTMLElement = CreateElement("div",{classes:["dialog"],parentToAppend:messageContainer, 
			style:
				{
					position:"absolute",
					width: Scale.Hpx(1152),
					height: Scale.Hpx(648),
					backgroundSize: "contain",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
					backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["dialog", "image"])).CssBackground(),
				}
		});
		let bigSymbolFGMessageSpanish: HTMLElement = CreateElement("span",{
			style:
			{
				position: "absolute",
				width: Scale.Wpx(1152),
				height: Scale.Hpx(512),
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
				backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["end", "spanish"])).CssBackground(),


			}
		});
		let bigSymbolFGMessageEnglish: HTMLElement = CreateElement("span",{
			style:
			{
				position: "absolute",
				width: Scale.Wpx(1152),
				height: Scale.Wpx(512),
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
				backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["end", "english"])).CssBackground(),


			}
		});
		
		dialog.appendChild(this.translator.Anchor(()=> this.translator.t.BigFG(bigSymbolFGMessageSpanish.outerHTML, bigSymbolFGMessageEnglish.outerHTML)));

		

		let buttonContainer: HTMLElement = CreateElement("div", {classes:["buttonContainer"], parentToAppend:dialog, 
			style:
			{
				position:"absolute",
				bottom: Scale.Wpx(-129),
				width: Scale.Wpx(1152),
				height: Scale.Wpx(300),
				display: "flex",
				justifyContent: "center",
				alignItems: "center"
			}
		})
		
		let button: HTMLElement = CreateElement("div", {classes:["button"], parentToAppend:buttonContainer, 
			style:
			{
				width: Scale.Wpx(600),
				height: Scale.Hpx(300),
				fontSize: Scale.fhpx(100),
				display: "flex",
				justifyContent:"center",
				alignItems:"center",
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat:"no-repeat",
				backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["button", "image"])).CssBackground(),
			}
		});
		
		let text=this.translator.Anchor(()=> this.translator.t.freegameExit);

		this.SetTextCanvas(text.innerText,this.ButtonCanvas[1]);
		button.appendChild(this.ButtonCanvas[1].View());
	
		AddMouseDownListener(button, () => {
			if (this.stateMachine.State() == BigSymbolFreegamesState.FinalMessage) {
				// Log.Debug(this.logGroup, "Picked message confirmed");
				setTimeout(() => this.stateMachine.ChangeState(BigSymbolFreegamesState.Idle), 2500);			
				//SHOW VIDEO TRANSITION
				//Add more delay because video its very long 
				this.ShowVideoTransition();
			}
			else {
				Log.Error(this.logGroup, "Can't confirm intro message, current state: " + BigSymbolFreegamesState[this.stateMachine.State()] + ", required state: " + BigSymbolFreegamesState[BigSymbolFreegamesState.IntroMessage]);
			}
		});
	}

	protected PrepareReelsContainer(resourceManager: IReadOnlyResourceManager):void
	{
		this.reelsContainer = CreateElement("div",{classes:["reelsContainer"], parentToAppend:this.view,
			style:{
				width: Scale.Wpx(1920),
				height: Scale.Wpx(1080),
			}
		})
	}

	protected async BasePrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		//resourceManager.Add(new HTMLResource(this.params.commonPath + "resources/BigSymbolFreegames/resourcesBigSymbolFreegames.html", this.resid.ScopedResourceName("html")));
		//resourceManager.Add(new CSSResource(this.params.commonPath + "resources/BigSymbolFreegames/resourcesBigSymbolFreegames.css", this.resid.ScopedResourceName("css"), this.resid.CSSScope()));

		await this.PrepareFonts(resourceManager);
		await this.BackgroundPrepare(resourceManager);

		resourceManager.Add(new ImageResource(this.params.gamePath + "resources/dialog.png", this.resid.ScopedResourceName(["dialog", "image"])));
		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "background.jpg", this.resid.ScopedResourceName(["background", "image"])));


		resourceManager.Add(new ImageResource(this.params.gamePath + "resources/button.png", this.resid.ScopedResourceName(["button", "image"])));

		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "column-a.png", this.resid.ScopedResourceName(["columnleft", "image"])));
		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "column-b.png", this.resid.ScopedResourceName(["columnright", "image"])));

		//resourceManager.Add(new SpriteResource(this.params.gameResourcesBasePath + "transition", this.resid.Add("transition"), true, this.logGroup.Add("transition"), true));

		//LOAD DIAMOND POT SPRITE
		resourceManager.AddGlobal(new SpriteResource(this.params.commonPath + "resources/BigSymbolFreegames/resources/freegameTitle", ResourceIdentifier.Global.Add("BigSymbolFreegames").Add("title"), true, LogGroup.Global.Add("BigSymbolFreegames").Add("title"), true))

		// // use game presentation video as transition video
		// if (this.ScreenNumberConfiguration == 3) {
		// 	resourceManager.AddGlobal(new VideoResource2({
		// 		src: Settings.ResourcesFolder + "multigame/slot/" + this.gameName + "/resources/video/presentation_3s",
		// 		resid: ResourceIdentifier.Global.Add(this.gameName),
		// 		logGroup: LogGroup.Global.Add(this.gameName),
		// 		unloadOnHide: true
		// 	}));
		// }
	

		resourceManager.Add(new ImageResource(this.params.commonPath + "resources/BigSymbolFreegames/resources/ContainerText/STICKY-BONUS-END-TEXTS_ENGLISH.png", this.resid.ScopedResourceName(["end", "english"])));
		resourceManager.Add(new ImageResource(this.params.commonPath + "resources/BigSymbolFreegames/resources/ContainerText/STICKY-BONUS-INTRO-TEXT_ENGLISH.png", this.resid.ScopedResourceName(["intro", "english"])));

		resourceManager.Add(new ImageResource(this.params.commonPath + "resources/BigSymbolFreegames/resources/ContainerText/STICKY-IBONUS-END-TEXTS_SPANISH.png", this.resid.ScopedResourceName(["end", "spanish"])));
		resourceManager.Add(new ImageResource(this.params.commonPath + "resources/BigSymbolFreegames/resources/ContainerText/STICKY-IBONUS-NTRO-TEXTS_SPANISH.png", this.resid.ScopedResourceName(["intro", "spanish"])));


	}

	protected BackgroundPrepare(resourceManager: IWriteOnlyResourceManager) {
		//yo
		resourceManager.Add(new ImageResource(this.params.gamePath + "resources/BigSymbolFreegames/"+"background"+this.ScreenNumberConfiguration+"S/"+"background.png", this.resid.ScopedResourceName(["background", "image"])));
		//yo arriba
		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "background.2.jpg", this.resid.ScopedResourceName(["background.2", "image"])));
		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "background.3.jpg", this.resid.ScopedResourceName(["background.3", "image"])));
	}

	protected PrepareFonts(resourceManager: IWriteOnlyResourceManager): void {

		resourceManager.Add(new FontResource(this.params.commonPath + "resources/BigSymbolFreegames/resources/newzone.ttf", this.resid.ScopedResourceName("bigwincount")));
		//resourceManager.Add(new FontResource(this.params.gameResourcesBasePath + "huggable.ttf", "." + this.resid.ScopedResourceName(["lines", "font"])));
	}

	protected gameBackground: ImageResource = null;
	protected async BaseLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		this.gameBackground = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background", "image"]));

		SetStyles(this.backgroundBigFreeGame, {
			backgroundImage: this.gameBackground.CssBackground(),
			backgroundSize: "100%",
		});
		//this.view.innerHTML += resourceManager.Get<HTMLResource>(this.resid.ScopedResourceName("html")).html;
		this.reelsContainer = this.view.querySelector(".reels");

		//this.gameBackground = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background", "image"]));
		//Yo
		//this.gameBackground = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background", "image"]));
		//Yo
		//this.view.style.backgroundImage = this.gameBackground.CssBackground();

        // if (this.ScreenNumberConfiguration == 3)
        // {
        //     let transitionVideo: MyVideo = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add(this.gameName)).video;
        //     transitionVideo.View().style.position = "absolute";
        //     transitionVideo.View().style.zIndex = "" + ZIndex.BonusTransition;
        //     this.systemContext.SharedVideoContext().AddVideo(transitionVideo);
        //     transitionVideo.AddOnPlayCallback(this.resid, () => this.OnTransitionStarted());
        //     transitionVideo.AddOnEndedCallback(this.resid, () => this.OnTransitionEnded());
        // }

	}

	protected async PrepareHistory(resourceManager: IWriteOnlyResourceManager) {
	}

	protected async LoadedHistory(resourceManager: IReadOnlyResourceManager) {
	}


	/**
	 *	BIG WIN
	 */
	protected async BigWinPrepare(resourceManager: IWriteOnlyResourceManager): Promise<void >
	{
	}

	protected async BigWinLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		//this.winMessageAnimation = new WinMessageAnimation(this.params.screenSize);
		//this.shakeAnimation = new ShakeAnimation(this.spinnableReels.GetView());
		//this.bigWinCountAnimation = new BigWinCountAnimation(new Size(this.spinnableReels.GetWindowSize().width, 250), 150,this.resid.ScopedResourceName("bigwincount"));

		// messages
		// for (let i = 0; i < this.wins.length; i++) {
		// 	let message = new WinMessage(this.wins[i].name, resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("winmsg").Add(this.wins[i].name)).sprite.Copy(), this.wins[i].winMultiplier, this.audio.Track(this.resid.ScopedResourceName(this.wins[i].name)));
		// 	this.winMessageAnimation.AddMessage(message);
		// }

		// this.view.appendChild(this.winMessageAnimation.View());


		// quit dont need fountain
		//let fountainAnimation = SlotGameExport type1Shared.Instance().smallFountainAnimation;
		//fountainAnimation.AddOnStartCallback(this.resid, () => this.audio.PlayLoop(this.parentresid.ScopedResourceName("fountain")));
		//fountainAnimation.AddOnStopCallback(this.resid, () => this.audio.Stop(this.parentresid.ScopedResourceName("fountain")));


		// let countView = this.bigWinCountAnimation.View();
		// countView.style.position = "absolute";
		// countView.style.top = "500px";
		// countView.style.left = this.params.windowRectangle.x + "px";
		// countView.style.pointerEvents = "none";

		// this.view.appendChild(this.bigWinCountAnimation.View());
	}

	/**
	 *	FEATURES
	 *  TODO check what features are actually enabled in freegames!
	 */
	protected async FeaturesPrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> {

		// PLUS ONE
		{
			let params:PlusOneParams={
				viewSize : this.params.screenSize,
				spinnableReels : this.spinnableReels2,
				logGroup:this.logGroup,
				resid:this.resid,
				bonusName:this.bonusName,			
				maxAdditionalFreegames : this.maxAdditionalFreegames,
				gameBonusResourcesBasePath : this.params.gamePath,	
			}

			this.plusOneAnim = this.plusOneFactory.CreatePlusOne(params);
			await this.plusOneAnim.PrepareResources(resourceManager);
		}
		//resourceManager.Add(new ImageResource(this.params.commonPath + "resources/BigSymbolFreegames/resources/coin.png", this.resid.ScopedResourceName(["plusone", "image"])));
		//resourceManager.AddGlobal(new SpriteResource(this.params.gameResourcesBasePath + "bonus", ResourceIdentifier.Global.Add("BigSymbolFreegames").Add(this.gameName), true, this.logGroup.Add(this.gameName), true));

		{
			let params: ScatterRandomAwardCreateParams = 
			{
				logGroup: this.logGroup,
				resid: this.resid,
				// reelSet: this.params.config.ReelSet.map(rs => rs.Symbols),
				availableSymbols: this.params.symbols
			};

			//let config: ScatterRandomAwardConfiguration = this.config.FeatureConfigurations.find(f => f && f.FeatureType == "ScatterRandomAward") as ScatterRandomAwardConfiguration;

			this.scatterRandomAwardFeature = new ScatterRandomAward(params, {"ScatterRandomAward": this.config.FeatureConfigurations.find(f => f.FeatureType == "ScatterRandomAward") as ScatterRandomAwardConfiguration},  this.params.color);
			await this.scatterRandomAwardFeature.PrepareResources(resourceManager);
		}

		// {
		// 	let params: HoldingFeatureParams = {
		// 		logGroup: this.logGroup,
		// 		resid: this.resid,
		// 		spinnableReels: this.spinnableReels2
		// 	};
			
		// 	this.holdingFeature = new HoldingFeature(params);
		// 	this.holdingFeature.PrepareResources(resourceManager);
		// }
	}

	protected async FeaturesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		
		{
			this.plusOneAnim.ResourcesLoaded(resourceManager);
			this.plusOneAnim.View().style.zIndex = ZIndex.PlusOne.toString();
			this.view.appendChild(this.plusOneAnim.View());
		}

		{
			await this.scatterRandomAwardFeature.ResourcesLoaded(resourceManager);
		}

		// {
		// 	this.holdingFeature.ResourcesLodaded(resourceManager, this.scatterRandomAwardFeature.GetAwardOptions());
		// 	//this.holdingFeature.SetAwardOptions(this.scatterRandomAwardFeature.GetAwardOptions());
		// 	this.view.appendChild(this.holdingFeature.View());
		// }


	}

	protected async CometsPrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		// TODO share comets with pickbonus or use separate comets?
		resourceManager.AddGlobal(new SpriteResource(Settings.ResourcesFolder + "multigame/slot/common/resources/PickBonus/comet", ResourceIdentifier.Global.Add("PickBonus").Add("Commet"), true, LogGroup.Global.Add("PickBonus").Add("Commet"), true))
	}

	protected async CometsLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		this.comet = new Comet(new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("PickBonus").Add("Commet")).sprite.Copy(), canvasSize: null, drawFirstFrame: true, sizing: CanvasSpriteSizing.Stretch}));
		
		SetStyles(this.comet.View(), {
			position: "absolute",
			top: Scale.Ypx(0),
			left: Scale.Xpx(0),
			zIndex: ZIndex.Jp1Comet.toString()
		});

		this.view.appendChild(this.comet.View());
    }
    
	protected colorLineMarkers: MarkersInfoColors =
	{
		MarkerbackgroundColor: "linear-gradient(90deg, rgba(6,65,42,1) 0%, rgba(117,255,9,1) 35%, rgba(183,255,9,1) 55%, rgba(117,255,9,1) 75%, rgba(6,65,42,1) 100%), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		//linearColor:"linear-gradient(to left , transparent, LightGoldenrodYellow,transparent ) 0 10 100%",
	};

    protected async PrepareWinLines(resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		// construct win lines
		let winLinesAnimParams: WinLinesAnimationParams =
		{
			viewSize: this.params.screenSize,
			spinnableReels: this.spinnableReels2,
			lines: this.params.playlines,
			logGroup: this.logGroup,
			resid: this.resid,
			systemContext: this.systemContext,
			slotWindow : this.params.windowRectangle,
			slotWindowSymbolSize :this.spinnableReels2.GetWindowSymbolSize(),
			colorLineMarkers : this.colorLineMarkers,
			speedFactorAnimation: this.params.FpsFactor,
			gameName : this.gameName,
			winLinesTypeStyle : WinLinesTypeStyle.default,
		};

		// TODO replace with factory
        this.winLinesAnimation = this.winLinesFactory.CreateWinLines(winLinesAnimParams);


		this.winLineMarkers = new WinLineMarkers(this.params.windowRectangle, this.spinnableReels2.GetWindowSymbolSize(), this.params.playlines);

		this.winLinesAnimation.AddStartLineCallback((line: LineWin, color: Color) => 
		{
			this.audio.PlayLoop(this.parentresid.ScopedResourceName("linecount"));
		});

		this.winLinesAnimation.AddNextLineCallback((line: LineWin, color: Color, animateOnlyWinningSymbols: boolean) => 
		{
			this.winLineMarkers.Show(line.LineIndex, color);
			this.panel.SetMessage(this.translator.t.linepay("" + (line.LineIndex +1), service.moneyFormatter.FormatCreditCurrentDenom(line.Win)));
			let lineindex:number = line.LineIndex;

			let symbolsToAnimate: number = this.params.playlines[lineindex].length;
			if (animateOnlyWinningSymbols)
			{
				symbolsToAnimate = line.SymbolCount;
			}

			let symbolPositions: SymbolPositionToAnimate[] = [];
			for(let columnIndex = 0; columnIndex < symbolsToAnimate; columnIndex++)
			{
				let row = this.params.playlines[lineindex][columnIndex];
				let pos = this.spinnableReels2.GetSymbolAt(columnIndex, row);
				symbolPositions.push(new SymbolPositionToAnimate(pos.reelIndex, pos.rowIndex));
			}

			// filter unique
			symbolPositions = symbolPositions.filter((pos1, index, array) => array.findIndex(pos2 => pos1.reel == pos2.reel && pos1.row == pos2.row) == index);

			this.screenProtocol?.Send(new SlotGameMessages.WiningSymbol(line.SymbolIndex), this.screenProtocolScope);

			this.symbolsAnimation.Stop();
			this.symbolsAnimation.Update();
			this.symbolsAnimation.Start(symbolPositions);
		});

		this.winLinesAnimation.AddCompleteCallbacks(() => 
		{
			this.winLineMarkers.Hide();
			
			this.audio.Stop(this.parentresid.ScopedResourceName("linecount"));
			//this.audio.Play(this.parentresid.ScopedResourceName("linecountend"));
			this.stateMachine.ChangeState(BigSymbolFreegamesState.Collect); 
		});

		await this.winLinesAnimation.PrepareResources(resourceManager);
    }

	// protected OnNextBonusBegin(){
	// 	if (this.currentBonus)	{
	// 		this.simpleBonusSpinResult = this.simpleAllBonusSpinResult  as BigSymbolFreegamesSpinAction [];
			
	// 		this.currentBonus.Prepare(this.simpleAllBonusSpinResult.filter(b => b.Bonus == "BigSymbolSpinAndHold"), this.bet);
	// 		this.currentBonus.ShowVideoTransition();
	// 		this.view.style.display = "none";
	// 		this.currentBonus.SetBonusFinishedCallback(()=>{
	// 			this.currentBonus.Hide();
	// 			this.screenProtocol.Send(new SlotGameMessages.BonusFinished(), this.screenProtocolScope);				
	// 			// Log.Debug(this.logGroup,"Current Bonus to hide " + this.currentBonus.Name());
	// 			this.currentBonus = null;
	// 			// Log.Debug(this.logGroup,"Removing bonus");	
	// 			if(this.spinIndexData < this.simpleBonusSpinResult.length){
	// 				this.stateMachine.ChangeState(BigSymbolFreegamesState.SpinIdle, {reason: "Bonus are finished into bonus"});
	// 				// Log.Debug(this.logGroup,"Bonus its finished into bonus");					
	// 			}
	// 		})				
	// 		setTimeout(() => {
	// 			this.robotPlay.BonusStarted(this.currentBonus);
	// 			this.currentBonus.Show();					
	// 			this.audio.Stop(this.resid.ScopedResourceName("background"));					
	// 			this.screenProtocol.Send(new SlotGameMessages.BonusStart(this.currentBonus.Name()), this.screenProtocolScope);
	// 			this.currentBonus.Start();
	// 			this.view.style.display = "block";
	// 			}, 1000);
	// 	}
	// 	else {
	// 		this.stateMachine.ChangeState(BigSymbolFreegamesState.Collect);
	// 			//this.stateMachine.ChangeState(SlotGameState.Collect);
	// 	}
	// }
		
	
    
    protected async WinLinesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
    {
        await this.winLinesAnimation.ResourcesLoaded(resourceManager);

        this.reelsContainer.appendChild(this.winLinesAnimation.View());
		this.reelsContainer.appendChild(this.winLineMarkers.LeftView());
		this.reelsContainer.appendChild(this.winLineMarkers.RightView());
	}
	
	protected TranslationsLoaded(resourceManager: IReadOnlyResourceManager): void
	{
		// this.View().querySelector(".header").appendChild(this.translator.Anchor(() => this.translator.t.fregameheader));
		// this.View().querySelector("#contents1").appendChild(this.translator.Anchor(() => this.translator.t.freegamemassage1));
		// this.View().querySelector(".bonusName").appendChild(this.translator.Anchor(() => this.translator.t.freegamemassage3));
		// this.View().querySelector("#contents2").appendChild(this.translator.Anchor(() => this.translator.t.freegamemassage2));
		// this.View().querySelector("#contents3").appendChild(this.translator.Anchor(() => this.translator.t.freegamemassage4));

		// this.View().querySelector(".startbut").appendChild(this.translator.Anchor(() => this.translator.t.freegamemassage5));
	}

	protected async DemoLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		 if (this.params.slotGameMeta.Demo == true) {

			this.view.appendChild(this.demoMessage);
		}
	}

	/**
	 *	REELS
	 */

	 protected ExtraSymbolsAbove():number
	 {
		 //Add One Extra Symbol
		 let reel:number=1;
		 return reel
	 }
	protected async PrepareReels(resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		{
			// let reelConfig: S2_ReelConfig[] = [
			// 	{Name: "left", Index: 0, Row: 0, Col: 0, ColSpan: 1, RowSpan: 3, Height: 3, Symbols: []},
			// 	// {Name: "left", Index: 0, Row: 0, Col: 0, ColSpan: 1, RowSpan: 1, Height: 1, Symbols: []},
			// 	// {Name: "left", Index: 1, Row: 1, Col: 0, ColSpan: 1, RowSpan: 1, Height: 1, Symbols: []},
			// 	// {Name: "left", Index: 2, Row: 2, Col: 0, ColSpan: 1, RowSpan: 1, Height: 1, Symbols: []},
		
			// 	{Name: "right", Index: 1, Row: 0, Col: 4, ColSpan: 1, RowSpan: 3, Height: 3, Symbols: []},
			// 	// {Name: "right", Index: 3, Row: 0, Col: 4, ColSpan: 1, RowSpan: 1, Height: 1, Symbols: []},
			// 	// {Name: "right", Index: 4, Row: 1, Col: 4, ColSpan: 1, RowSpan: 1, Height: 1, Symbols: []},
			// 	// {Name: "right", Index: 5, Row: 2, Col: 4, ColSpan: 1, RowSpan: 1, Height: 1, Symbols: []},
		
				
			// 	{Name: "center", Index: 2, Row: -3, Col: 1, ColSpan: 3, RowSpan: 6, Height: 2, Symbols: []}
			// ];

			// this.config.ReelSet = reelConfig;

			// update center reel so it is visible 1 symbol above, in the 2. screen
			let centerReel: S2_IReelConfig = this.config.ReelSet.find(r => r.Name.toLowerCase() == "center");
			if (centerReel)
			{
				if (centerReel.Height != 1) throw "Center reel expected to be 1 symbol high";
				if (centerReel.Row != 0) throw "Center reel expected to start in row 0";
				if (centerReel.RowSpan != this.config.PlayWindow.Height) throw `Center reel expected have rowspan ${this.config.PlayWindow.Height}`;

				centerReel.ExtraSymbolsAbove = this.ExtraSymbolsAbove();
			}


			this.spinnableReels2 = new S2_SpinnableReels2(
				{
					reelConfig: this.config.ReelSet, 
					playWindow: this.config.PlayWindow,
				},
				{
					windowRect: this.params.windowRectangle,
					leftBorderWidth: this.params.spinnableReelsParams.leftBorderWidth,
					rightBorderWidth: this.params.spinnableReelsParams.rightBorderWidth,
					topBorderWidth: this.params.spinnableReelsParams.topBorderWidth,
					bottomBorderWidth: this.params.spinnableReelsParams.bottomBorderWidth,
				}
			);

			let reelSpinAnimations: S2_ReelSpinAnimation[] = [];
			let animationColumns: number[] = this.spinnableReels2.GetAnimationColumns();
			

			// create animation for each column
			animationColumns.forEach((animationColumn, animationColumnIndex) => {

				
				let symbolHeight = this.spinnableReels2.GetReelsInAnimationColumn(animationColumnIndex)[0].SymbolSizeInPixels.Height;
				let params: S2_ReelSpinAnimParams = {
					logGroup: this.logGroup,
					columnIndex: animationColumnIndex,
					symbolHeightInPixels: symbolHeight,
					overshootHeightInSymbols: symbolHeight * 0.125,
					deccelerationHeightInSymbols: this.spinnableReels2.GetMaxReelHeightInSymbols() +1,
					speedCorrection: 0.90*0.30, //this.spinnableReels2.GetOriginalSymbolSize().height / this.spinnableReels2.GetMaxSymbolHeight(), // * 0.025,
					//durationCorrection: 1,
                    delay: 400
				};
		
				let reelSpinAnimation = new S2_ReelSpinAnimation(params);
				reelSpinAnimations.push(reelSpinAnimation);


				reelSpinAnimation.AddOnUpdateCallback((params) => this.ReelColumnUpdate(params));


				reelSpinAnimation.AddOnStartCallback((anim) => {
					let reelsToAnimate: S2_ISpinnableReel[] = this.spinnableReels2.GetReelsInAnimationColumn(anim.ColumnIndex);

					for(let r = 0; r < reelsToAnimate.length; r++)
					{
						let reelToAnimate = reelsToAnimate[r];

						// start reel mapper
						let reelMapper = this.reelSetMapper2.GetReelMapper(reelToAnimate.Config.Index);
						reelMapper.Start();

						reelToAnimate.SpinMaskElement.style.overflow = "hidden";
						reelToAnimate.TopHiddenSymbols.style.visibility = "";
						reelToAnimate.BottomHiddenSymbols.style.visibility = "";
						reelToAnimate.ReelWindowElement.style.overflow = "hidden";
					}
				});

				reelSpinAnimation.AddOnDeccelerationCallbak((anim, params) => {
					let reelsToAnimate: S2_ISpinnableReel[] = this.spinnableReels2.GetReelsInAnimationColumn(anim.ColumnIndex);

					for(let r = 0; r < reelsToAnimate.length; r++)
					{
						let reelToAnimate = reelsToAnimate[r];
						let reelMapper = this.reelSetMapper2.GetReelMapper(reelToAnimate.Config.Index);
						let distanceInSymbols = params.totalDistanceInSymbols;
						reelMapper.Slice(distanceInSymbols);
					}
                });
                
                reelSpinAnimation.AddOnNearCompleteCallback((anim) => {

                    let reelsToAnimate: S2_ISpinnableReel[] = this.spinnableReels2.GetReelsInAnimationColumn(anim.ColumnIndex);

					// allow overflow
					for(let r = 0; r < reelsToAnimate.length; r++)
					{
						let reelToAnimate = reelsToAnimate[r];
						reelToAnimate.SpinMaskElement.style.overflow = "";
					}


					// // find what bonuses have triggering symbols in current column

					// let reelCurrentColumn: number[] = reelsToAnimate.map(r => r.Config.Index);
					// let allBonuses: Bonus[] = Object.keys(this.lastSpinResult.TriggerResults) as Bonus[];

					// // find all bonuses, that have triggering symbol in current column (column can have multiple reels)
					// let bonusesCurrentColumn: Bonus[] = allBonuses.filter(bonus => 
					// {
					// 	let triggerPositions: SymbolPosition[] = this.lastSpinResult.TriggerResults[bonus].symbolsTriggered || [];
					// 	// filter only current column
					// 	let triggerPositionsThisReels: SymbolPosition[] = triggerPositions.filter(p => reelCurrentColumn.includes(p.Reel));

					// 	// if there is symbol for "bonus" in this column, keep the name
					// 	return triggerPositionsThisReels.length > 0;
					// });

					let anyReelSpinning = !this.session.HoldReels || reelsToAnimate.filter(r => !this.session.HoldReels[r.Config.Index]).length > 0;
					if (anyReelSpinning)
					{
						// some reels are spinning in this column, play sound
					}

					let columnContainsBigReel = reelsToAnimate.filter(r=> r.Config.ColSpan >1).length >0;
					if(columnContainsBigReel)
					{
						this.audio.Play(this.resid.ScopedResourceName("bigreelSpinStop"));
					}
					else
					{
						this.audio.Play(this.resid.ScopedResourceName("reelstop"));
					}
				});

				reelSpinAnimation.AddOnCompleteCallback((anim) => {
					
					let reelsToAnimate: S2_ISpinnableReel[] = this.spinnableReels2.GetReelsInAnimationColumn(anim.ColumnIndex);

					for(let r = 0; r < reelsToAnimate.length; r++)
					{
						let reelToAnimate = reelsToAnimate[r];

						reelToAnimate.SpinMaskElement.style.overflow = "";
						reelToAnimate.TopHiddenSymbols.style.visibility = "hidden";
						reelToAnimate.BottomHiddenSymbols.style.visibility = "hidden";
						reelToAnimate.ReelWindowElement.style.overflow = "";
					}
				});
				
			});

			this.spinAnimation2 = new S2_SpinAnimation(this.logGroup, this.config.ReelSet, reelSpinAnimations);
			this.spinAnimation2.AddOnStartCallback(() => {

			});
			this.spinAnimation2.AddOnCompleteCallback(() => {
				this.SpinComplete();
				this.audio.Stop(this.parentresid.ScopedResourceName("anticipation"));
				this.stateMachine.ChangeState(BigSymbolFreegamesState.Features);
			});

			if( Settings.touchToStop == true){
				AddMouseDownListener(this.spinnableReels2.GetView(), () => {
					this.spinAnimation2.RequestStop();
				});
			}
		}


		this.reelSetMapper2 = new S2_ReelSetMapper(this.params.playWindow, this.logGroup);
		this.config.ReelSet.forEach((reelConfig, reelIndex) => {
			let m: S2_ReelMapper = new S2_ReelMapper(reelIndex, this.logGroup,reelConfig.Height, this.spinnableReels2.GetReel(reelIndex).ReelDisplayGeometry);
			
			// TODO add start position?
			// TODO add extended symbols?
			m.SetReel(reelConfig.Symbols, reelConfig.StartPosition || 0)
			this.reelSetMapper2.AddReelMapper(m);
		});

		this.currentSymbols = this.reelSetMapper2.GetSymbols2();

		// prepare backgrounds
		let differentBackgrounds: string[] = this.spinnableReels2.GetReels()
			// generate name for each reel
			.map(reel => reel.BackgroundRect_symbols.Size().Width + "x" + reel.BackgroundRect_symbols.Size().Height)
			// filter only unique
			.filter(Filter.UniqueItem);

		differentBackgrounds.forEach(reelsize => 
		{
			resourceManager.Add(new ImageResource(this.params.gamePath + "resources/BigSymbolFreegames/reel_" + reelsize + ".png", this.resid.ScopedResourceName(["reelbackground", reelsize])));
		});

		this.symbolsAnimation = new SpecificSymbolsAnimation(this.params.symbolSpriteAnims, this.spinnableReels2, this.reelSetMapper2, this);
		this.bonusTriggerAnimation = new SpecificSymbolsAnimation(this.params.symbolSpriteAnims, this.spinnableReels2, this.reelSetMapper2, this);
	}

	protected async ReelsLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		// set backgrounds
		this.spinnableReels2.GetReels().forEach(reel =>
		{
			let backgroundSize = reel.BackgroundRect_symbols.Size().Width + "x" + reel.BackgroundRect_symbols.Size().Height;
			let imgResource: ImageResource = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["reelbackground", backgroundSize]));
			reel.WindowBackgroundElement.style.background = imgResource.CssBackground() + " no-repeat center / 100% 100%";
		});

		this.reelsContainer.appendChild(this.spinnableReels2.GetView());
	}

	protected ReelColumnUpdate(params: S2_ReelSpinAnimationUpdateParams): void
	{
		//if (anim.ColumnIndex != 0) return;

        let reelsToAnimate: S2_ISpinnableReel[] = this.spinnableReels2.GetReelsInAnimationColumn(params.reelSpinAnimation.ColumnIndex);

        for(let reelIndex = 0; reelIndex < reelsToAnimate.length; reelIndex++)
        {
            let reelToAnimate = reelsToAnimate[reelIndex];
			
			// Don't animate when holding
			if (this.session.HoldReels &&
				this.session.HoldReels[reelToAnimate.Config.Index] >= 0
			)
			{
				continue;
			}

            // let distanceInSymbols = Math.floor(distance / reelToAnimate.SymbolSizeInPixels.height);
			// let translate = distance % reelToAnimate.SymbolSizeInPixels.height;
			
			//// Log.Debug(this.logGroup, `ReelColumnUpdate translate distance: ${distance}, symbol height: ${reelToAnimate.SymbolSize.height}, distance in symbols: ${distanceInSymbols}`);
            let translateStr = `translateY(${params.modSymbolDistance}px)`;

			reelToAnimate.ReelElement.style.transform = translateStr;



			let reelMapper = this.reelSetMapper2.GetReelMapper(reelToAnimate.Config.Index);
			reelMapper.Update(params.symbolDistance);

			if (reelMapper.DidSymbolsChange())
			{
				this.currentSymbols[reelToAnimate.Config.Index] = reelMapper.GetSymbols2();

				for (let rowIndex: number = 0; rowIndex < reelToAnimate.ReelDisplayGeometry.symbolsTotal; rowIndex++)
				{
					this.DrawSymbol(reelToAnimate.Config.Index, rowIndex);
				}
			}
		}
	}

	protected currentSymbols: ReelSymbolsToDisplay[][] = [];
	public DrawSymbol(reelIndex: number, rowIndex: number): void
	{
		let reel: S2_ISpinnableReel = this.spinnableReels2.GetReel(reelIndex);

		let canvas: MyCanvas = this.spinnableReels2.canvas[reelIndex][rowIndex];
		let symbolToDisplay: ReelSymbolsToDisplay = this.currentSymbols[reelIndex][rowIndex];
		let symbol: SlotSymbol = this.params.symbols[symbolToDisplay.symbolIndex];

		let scale = Math.min(reel.originalSymbolScaleX, reel.originalSymbolScaleY);
		
		//canvas.context.save();

		canvas.context.resetTransform();
		canvas.context.translate(canvas.rect.centerx, canvas.rect.centery);
		canvas.context.scale(scale, scale);
		canvas.context.translate(-canvas.rect.centerx, -canvas.rect.centery);

		this.params.symbolSpriteAnims[symbolToDisplay.symbolIndex].Draw(canvas);
		this.scatterRandomAwardFeature.Draw(reelIndex, symbolToDisplay.reelPositionIndex, rowIndex, symbol, canvas);

		//canvas.context.restore();
	}

	public Confirm(): void {
		if (this.stateMachine.IsState(BigSymbolFreegamesState.IntroMessage)) {
			// Log.Debug(this.logGroup, "Intro message confirmed");
			this.stateMachine.ChangeState(BigSymbolFreegamesState.WaitFirstSpin);
		}
		else if (this.stateMachine.IsState(BigSymbolFreegamesState.FinalMessage)) {
			// Log.Debug(this.logGroup, "Final message confirmed");
			//put some delay
			setTimeout(() => this.stateMachine.ChangeState(BigSymbolFreegamesState.Idle), 2500);
			//SHOW VIDEO TRANSITION
			//Add more delay because video its very long 
			this.ShowVideoTransition();
		}
		else {
			Log.Error(this.logGroup, "Can't confirm message, current state: " + BigSymbolFreegamesState[this.stateMachine.State()]);
		}
	}
	public Spin(): void {

		// Log.Debug(this.logGroup, "Spin");

		switch (this.stateMachine.State()) {
			//case BigSymbolFreegamesState.Running:

			// when in idle state, spin starts new spin
			case BigSymbolFreegamesState.SpinIdle:
			case BigSymbolFreegamesState.WaitFirstSpin:

				// make sure to clear timer, to prevent double spin??
				if (this.session.RunsRemaining > 0) {

					// Log.Debug(this.logGroup, "Spin: Requesting next spin");

					this.autospinDelay.Stop();
					this.spinInterrupted = false;

					this.spinAnimation2.Start();
					//ebugger;

					// protocol.Send("BonusNextRun", null);
					this.stateMachine.ChangeState(BigSymbolFreegamesState.Spin);
					
				}
				break;
			case BigSymbolFreegamesState.FinalMessage:
			case BigSymbolFreegamesState.IntroMessage:
				// Log.Debug(this.logGroup, "Spin: Confirming message");
				this.Confirm();
				break;

			case BigSymbolFreegamesState.Spin:
				// Log.Debug(this.logGroup, "Spin: Request spin stop");
				this.spinAnimation2.RequestStop(-1);
				break;

			case BigSymbolFreegamesState.Features:
				// Log.Debug(this.logGroup, "Spin: Request features stop");
				this.RequestFeatureStop();
				break;

			// When in win state, spin interrupts the count
			case BigSymbolFreegamesState.Win:
				// Log.Debug(this.logGroup, "Spin: Request win stop");
				this.spinInterrupted = true;
				this.winLinesAnimation.RequestStop();
				break;

			case BigSymbolFreegamesState.Bonus:
					if (this.currentBonus)
					{
						this.currentBonus.Spin();															
					}
				break;

			default:
				// Log.Debug(this.logGroup, "Spin: Nothing to do in current state: " + this.stateMachine.StateName);
				break;
		}
	}

	public AutoSpin(): void {
        if (this.params.bonusAutoplay && !this.isLocked)
        {
            // Log.Debug(this.logGroup, "Autospin");
            this.Spin();
        }
        else
        {
            // autospin is disabled
        }
	}

	// TODO change, remove, improve
	public Reset(): void {
		this.lastSpinResult = null;
	}

	private SpinComplete(): void {
	}

	public ReDrawCanvasButton()
	{
		this.SetTextCanvas(this.translator.t.freegameStart, this.ButtonCanvas[0]);
		this.SetTextCanvas(this.translator.t.freegameExit, this.ButtonCanvas[1]);
	}

	public Start(): void {
	

		this.ReDrawCanvasButton();

		// Log.Debug(this.logGroup, "Bonus started");

		//this.basegameWinCents = basegameWinCents;

		this.lastSpinResult = null;
		this.session.Reset();
		this.session.RunsPlayed = 0;
		let startBonusIndex =  this.startConfig.findIndex(b=>b.Action == "BigSymbolFreegamesStartAction" && b.Phase == "Start");
		this.spinIndexData = 0; //startBonusIndex;		
		this.session.RunsStarted = this.startConfig[startBonusIndex].SpinsStarted;
		this.session.RunsRemaining = this.startConfig[startBonusIndex].SpinsStarted;
		// this.session.ScattersDisplayed = this.startConfig.StartingState.FeatureResults.ScatterRandomAward &&
		// 	this.startConfig.StartingState.FeatureResults.ScatterRandomAward.ScattersTotal || 0;

		this.stateMachine.ChangeState(BigSymbolFreegamesState.IntroMessage);
		//this.stateMachine.ChangeState(BigSymbolFreegamesState.WaitFirstSpin);

		// Log.Debug(this.logGroup, "Bonus started");

		this.Show();

		this.PanelRequired(true);
		
		this.audio.Stop(this.resid.ScopedResourceName("background"));
		this.audio.PlayLoop(this.resid.ScopedResourceName("background"));

		// TODO use different message for start instead of SPIN
		this.screenProtocol?.Send(new BigSymbolFreegamesMessages.SpinMessage(this.session), this.screenProtocolScope);
	}


	public Show() {
		this.view.style.display = "block";
	}

	public Hide() {
		this.view.style.display = "none";
	}



	public Update(): void {
		//this.plusOneAnim.Update();
		this.spinAnimation2.Update();
		//this.transition.Update();

		//this.features.forEach((feature) => feature.Update());

		this.symbolsAnimation.Update();
		this.bonusTriggerAnimation.Update();
		//this.winMessageAnimation.Update();
		//this.shakeAnimation.Update();
		//SlotGameExport type1Shared.Instance().Update();


		//this.titleSprite.Update();
		//this.holdingFeature.Update();

		this.winLinesAnimation.Update();
		this.plusOneAnim.Update();
		this.comet.Update();
		//this.TitleSpriteTransition.Update();
		this.transitionView.Update();
		if (this.ButtonCanvas[0].WasContextLost() || this.ButtonCanvas[1]) {
			this.SetTextCanvas(this.translator.t.freegameStart, this.ButtonCanvas[0]);
			this.SetTextCanvas(this.translator.t.freegameExit, this.ButtonCanvas[1]);
		}
		//Redraw Reel Canvas Symbols 
		// check canvases
		for (let reelIndex = 0; reelIndex < this.spinnableReels2.canvas.length; reelIndex++) {
			for (let rowIndex = 0; rowIndex < this.spinnableReels2.canvas[reelIndex].length; rowIndex++) {
				if (this.spinnableReels2.canvas[reelIndex][rowIndex].WasContextLost()) {
					this.DrawSymbol(reelIndex, rowIndex);

					this.spinnableReels2.canvas[reelIndex][rowIndex].RestoreContext();
				}
			}
		}

		if (this.stateMachine.State() == BigSymbolFreegamesState.Bonus)
		{
			if (this.currentBonus)
			{
				this.currentBonus.Update();
			}
		}
	}

	public View(): HTMLElement {
		return this.view;
	}

	public GetSession(): GameSession {
		return this.session;
	}

	/**
	 *	Internal states
	**/
	private HideAllContainers(): void {
		this.containers.forEach((container, key) => container.style.display = "none");
	}

	private HideContainer(container: BigSymbolFreegamesContainer): void {
		// Log.Debug(this.logGroup, "Showing container " + BigSymbolFreegamesContainer[container]);

		let htmlElement = this.containers.get(container);
		if (htmlElement != null) {
			htmlElement.style.display = "none";
		}
		else {
			Log.Error(this.logGroup, "Container does not exist: " + BigSymbolFreegamesContainer[container]);
		}
	}


	private ShowContainer(container: BigSymbolFreegamesContainer): void {
		// Log.Debug(this.logGroup, "Showing container " + BigSymbolFreegamesContainer[container]);

		let htmlElement = this.containers.get(container);
		if (htmlElement != null) {
			htmlElement.style.display = "block";
		}
		else {
			Log.Error(this.logGroup, "Container does not exist: " + BigSymbolFreegamesContainer[container]);
		}
	}

	protected started:boolean=false;
	public ShowVideoTransition() {
		this.transitionView.ShowTransiton();
		this.OnTransitionStarted();

	}

	
	protected OnTransitionStarted() {
		//// Log.Debug(this.logGroup, "Transition started");
			// play transition audio
		this.audio.Play(this.resid.ScopedResourceName("transitionaudio"));
		
	}

	protected OnTransitionEnded(): void {
		// Log.Debug(this.logGroup, "Transition ended");
		this.started=false;

	}

	private OnIntroMessageBegin(): void {
		this.HideAllContainers();
		//this.transition.Start();

		



		this.ShowContainer(BigSymbolFreegamesContainer.Reels);
		this.ShowContainer(BigSymbolFreegamesContainer.IntroMessage);
		this.robotPlay.BonusConfirm("IntroMessage");
	}      

	private OnIntroMessageEnd(): void {
		//this.introMessageContainer.style.display = "none";
		//this.ShowContainer(BigSymbolFreegamesContainer.Reels);

		this.robotPlay.BonusConfirmAccepted();
	}

	public OnPicked(index: number): void {
	}

	
	protected triggerStartSoundLoop: ITimeout;
	protected introStartSound: ITimeout;
	public override TriggerAnimationStartedSprite(): void {		
		let delay: number = 1000;
		for (let i = 0; i < 3; i++) {
			setTimeout(() => this.audio.Play(this.resid.ScopedResourceName("triggered")), delay * (i + 1));
		}
	}

	public override TriggerAnimationStartedSpine(): void {		
		this.audio.Play(this.resid.ScopedResourceName("triggered"));		
	}


	
	public override BackGroundTransition(): void {		
		this.audio.Play(this.resid.ScopedResourceName("intro"));				
	}

	private OnWaitFirstSpinBegin(): void {
		//this.HideAllContainers();
		//this.ShowContainer(BigSymbolFreegamesContainer.Reels);
		this.HideContainer(BigSymbolFreegamesContainer.IntroMessage);
		this.PanelRequired(true);

		setTimeout(() => this.AutoSpin(), 1000);
	}

	protected OnSpinBegin(): void {
		this.session.RunsRemaining--;
		this.session.RunsPlayed++;

		this.audio.Play(this.parentresid.ScopedResourceName("leverpull"));

		this.screenProtocol?.Send(new BigSymbolFreegamesMessages.SpinMessage(this.session), this.screenProtocolScope);
		this.OnSimpleSpinRunResult();
		

	}
	public spinIndexData: number = 0;


	private OnSpinEnd(): void {
		this.audio.Stop(this.parentresid.ScopedResourceName("leverpull"));
		//missing data 
		//fix jorge 
		//this.session.HoldReels = this.lastSpinResult.HoldReels;
	}

	//protected currentFeature: SlotFeature = null;



	protected plusOneTarget: Point =  TranslatePointScreen2To1(new Point(Scale.X(228), Scale.Y(630)));
	private OnFeaturesBegin(): void {
		// do we have any features that triggered?

		this.session.RunsRemaining = this.simpleBonusSpinResult[this.spinIndexData].SpinsRemaining;
		this.session.RunsPlayed = this.simpleBonusSpinResult[this.spinIndexData].SpinsPlayed;
		//this.session.ScattersDisplayed = this.lastSpinResult.FeatureResults.ScatterRandomAward.ScattersTotal
		//this.currentFeature = null;


		//this.holdingFeature.Start(this.lastSpinResult.FeatureResults.ScatterRandomAward);

		let timeoutNextState: number = 0;
		
		
		if (this.currentBonus != null)
		{
			// Log.Debug(this.logGroup, "Symbol trigger feature");
			this.panel.SetMessage(this.translator.t.message_bonustriggered);
			
			let bonusTriggerSymbols: SymbolPosition[] = [];

			let triggerResult = this.simpleBonusSpinResult[this.spinIndexData].SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult
			if (triggerResult.FeatureTriggered && triggerResult.ScattersPosition)
			{
				triggerResult.ScattersPosition.forEach(p => bonusTriggerSymbols.push(p));
			}

			// filter unique
			bonusTriggerSymbols = bonusTriggerSymbols.filter((pos1, index, arr) => arr.findIndex(pos2 => pos1.Reel == pos2.Reel && pos1.Row == pos2.Row) == index);

			// convert
			let posToAnimate = bonusTriggerSymbols.map(pos => {
				let sym = this.spinnableReels2.GetSymbolAt(pos.Reel, pos.Row);
				return new SymbolPositionToAnimate(sym.reelIndex, sym.rowIndex);
			});

			this.bonusTriggerAnimation.Start(posToAnimate);

			this.currentBonus.TriggerAnimationStartedSprite();
			let timeout = 0;
			timeout += 4000;

			setTimeout(() => {
				//this.bonusTriggerAnimation.Stop();
				this.currentBonus.BackGroundTransition();
			}, timeout);

			timeoutNextState += 4000;
		}

		


		// if (this.lastSpinResult.FeatureResults.ScatterRandomAward &&
		// 	this.lastSpinResult.FeatureResults.ScatterRandomAward.ScattersAddedThisSpin > 0)
		// {

		// 	setTimeout(() => {
		// 		this.stateMachine.ChangeState(BigSymbolFreegamesState.BigWin);

		// 		// send when animation is finished, move to separate timeout if necessary
		// 		this.screenProtocol.Send(new BigSymbolFreegamesMessages.PlusMessage(this.session), this.screenProtocolScope);
		// 	}, 500);

		// 	timeout += 500;
		// }
		// else
		// {
		// 	this.stateMachine.ChangeState(BigSymbolFreegamesState.BigWin);
		// }

		//missing data 
		//fix jorge 
		//START
		
		if (this.simpleBonusSpinResult[this.spinIndexData].SpinWithFeatures.FeatureResults["PlusOneFeature"])
		{
			this.audio.Play(this.resid.ScopedResourceName("plusone"));
			let plusone = this.simpleBonusSpinResult[this.spinIndexData].SpinWithFeatures.FeatureResults["PlusOneFeature"] as unknown as PlusOneFeatureResult
			this.plusOneAnim.Start(plusone.SymbolPositions, this.plusOneTarget);

			let positions: SymbolPositionToAnimate[] = plusone.SymbolPositions.map(p => <SymbolPositionToAnimate>{
				reel: p.Reel,
				row: p.Row
			});
			this.symbolsAnimation.Start(positions);
			this.ApplySession(this.session.RunsRemaining);

			setTimeout(() => this.audio.Play(this.resid.ScopedResourceName("plusonemove")), 1000);
			setTimeout(() => {
				// send when animation is finished, move to separate timeout if necessary
				this.screenProtocol?.Send(new BigSymbolFreegamesMessages.PlusMessage(this.session), this.screenProtocolScope);
				this.symbolsAnimation.Stop();
			}, this.plusOneAnim.Duration());

			timeoutNextState = Math.max(timeoutNextState, this.plusOneAnim.Duration() + 1000);
		}
		//END


		setTimeout(() => this.stateMachine.ChangeState(BigSymbolFreegamesState.BigWin), timeoutNextState);
	}

	//Create For Update The Session For RunsRemaining 1 Screen Game
	protected ApplySession( RunsRemaining : number): void
	{
		//CREATE IN SlotGameExport type1_1Screen
	}

	protected RequestFeatureStop(): void {
		// if (this.currentFeature != null) {
		// 	this.currentFeature.RequestStop();
		// 	//this.symbolsAnimation.Update();
		// }
	}

	protected OnFeaturesEnd(): void {
		
		this.bonusTriggerAnimation.Stop();
		this.bonusTriggerAnimation.Update();

		this.symbolsAnimation.Stop();
		this.symbolsAnimation.Update();
	}



	// public FeatureFinished() {
	// 	// next feature, or continue to big win
	// 	this.currentFeatureIndex++;

	// 	if (this.currentFeatureIndex >= this.lastSpinResult.FeatureResults.length) {
	// 		this.stateMachine.ChangeState(BigSymbolFreegamesState.BigWin);
	// 	}
	// 	else {

	// 		for (; this.currentFeatureIndex < this.lastSpinResult.FeatureResults.length; this.currentFeatureIndex) {
	// 			if (this.lastSpinResult.FeatureResults[i].)
	// 		}
	// 	}
	// }

	private OnBigWinBegin(): void {


		//// Log.Debug(this.logGroup, "Big win message will not show");
		//this.stateMachine.ChangeState(BigSymbolFreegamesState.Win);
		this.stateMachine.ChangeState(BigSymbolFreegamesState.Win);

	}

	private OnBigWinEnd(): void {
	}

	
	private OnWinBegin(): void {

		// have some lines to display?
        if (this.simpleBonusSpinResult[this.spinIndexData].Win.ResultLines.length > 0)
        {
            let duration = Math.max(this.audio.Track(this.parentresid.ScopedResourceName("linecount")).Duration(), 0.2) * 2 * 1000;
            //let duration = 2000;
			this.winLinesAnimation.Start(this.simpleBonusSpinResult[this.spinIndexData].Win.ResultLines, duration);
			this.screenProtocol?.Send(new BigSymbolFreegamesMessages.TitleAnim(), this.screenProtocolScope);
	
			let winValues = {
				winCents: 0
			};
			
			
			//// Log.Debug(this.logGroup, `OnWinBegin() basegameWin: ${this.session.BasegameWinCents}, bonusTotalWin: ${this.lastSpinResult.TotalWin.InCents}, bonusRunWin: ${this.lastSpinResult.RunWin.InCents}`);
			console.log("BonusWin previous:", this.params.clientState.PreviousWin);
			console.log("BonusWin current:", this.params.clientState.Win);			
			this.winCreditAnimation = TweenMax.fromTo(winValues,
				this.winLinesAnimation.GetDuration()/1000, { winCents: this.params.clientState.PreviousWin },
				{
					winCents: this.params.clientState.Win,
					roundProps:"balance,win",

					onUpdate: ()=>
					{
						
						this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(winValues.winCents), service.moneyFormatter.FormatCurrency(winValues.winCents));
					},

					ease: Power0.easeNone
				}
			);

			setTimeout(() => this.robotPlay.OnSpinStopAvailable(), 1000);
        }
        else
        {
            this.stateMachine.ChangeState(BigSymbolFreegamesState.Collect);
        }
	}


	private OnWinEnd(): void {

		// stop win counting
		if (this.winCreditAnimation != null && this.winCreditAnimation.progress() != 1) {
			this.winCreditAnimation.progress(1, false);
		}

		this.symbolsAnimation.Stop();
	}

	// private OnLinesComplete(interrupted: boolean): void {
	// 	//this.winLineMarkers.Hide();
	// 	this.stateMachine.ChangeState(BigSymbolFreegamesState.Collect);
	// }

	private OnCollectBegin(): void {

		// TODO count up win?


		this.stateMachine.ChangeState(BigSymbolFreegamesState.Bonus);
		//this.screenProtocol.Send(new FreegameMessages.WinInterruptedMessage(), this.screenProtocolScope);
		this.panel.SetMessage(this.translator.t.goodluck);
	}
	

	private OnBonusBegin():void
	{
		let currentindexData = this.simpleAllBonusSpinResult.findIndex((b )=> b == this.simpleBonusSpinResult[this.spinIndexData]); 
		let nextBonusData = this.simpleAllBonusSpinResult.filter((b,index )=> index > currentindexData && b.Bonus == "BigSymbolSpinAndHold");
		
		if (this.currentBonus) {
			this.OnBonusRunFinished(nextBonusData);
			// wait for bonus to finish
			this.audio.Stop(this.resid.ScopedResourceName("background"));
			//this.OnNextBonusBegin();
		}
		else {
			this.stateMachine.ChangeState(BigSymbolFreegamesState.SpinIdle);
		}
	}

	private OnBonusEnd():void
	{
		this.PanelRequired(true);
		if (this.lastSpinResult != null) {

			if (this.lastSpinResult.NextBonus != null) {
				// wait for bonus to finish
				this.audio.PlayLoop(this.resid.ScopedResourceName("background"));
			}
		}
	}

	public NextBonusEnd() 
	{
		if(this.currentBonus != null)
		{
			this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.params.clientState.Win), service.moneyFormatter.FormatCurrency(this.params.clientState.Win));
			this.stateMachine.ChangeState(BigSymbolFreegamesState.SpinIdle);
		}
		else
		{
			Log.Error(this.logGroup, "no next bonus");
		}
	}



	private OnSpinIdleBegin(): void 
	{
		this.panel.OnIdleBegin();

		if (this.session.RunsRemaining > 0)
		{
			this.screenProtocol?.Send(new BigSymbolFreegamesMessages.TitleAnim(), this.screenProtocolScope);
	
			// put some delay before next spin
			if (this.spinInterrupted)
			{
				this.AutoSpin();
			}
			else
			{				
				this.autospinDelay.Start();
			}
		}
		else
		{
			// put some delay before final message
			setTimeout(() => this.stateMachine.ChangeState(BigSymbolFreegamesState.FinalMessage), 1000);
		}
	}

	private OnSpinIdleEnd(): void {
		this.panel.Stop();
	}

	protected OnCometCollectEnd(): void
	{

	}

	protected OnFinalMessageBegin(): void {
		//this.holdingFeature.Stop();


		this.audio.PlayLoop(this.resid.ScopedResourceName("final"));
		this.audio.Stop(this.resid.ScopedResourceName("background"));

		//Update the total win whit the last data in End bonus 
		this.session.TotalWin = this.simpleBonusSpinResult.find(b => b.Phase == "End").WinSinceGameStart.TotalWin.InCents;

		this.screenProtocol?.Send(new BigSymbolFreegamesMessages.ShowWinContainer(this.session), this.screenProtocolScope);
	



		this.PanelRequired(true);

		//this.HideAllContainers();
		//FINAL MESSAGE FOR TOTAL WIN
		//this.finalMessageContainer.querySelector(".totalWin").innerHTML = this.moneyFormatter.FormatCredit(this.lastSpinResult.TotalWin)

		this.ShowContainer(BigSymbolFreegamesContainer.FinalMessage);
		//this.transition.Start();
		this.VoicePlay = true;

		this.robotPlay.BonusConfirm("FinalMessage");
		//this.spinIndexData = 1;
	}

	protected OnFinalMessageEnd(): void {
		this.audio.Stop(this.resid.ScopedResourceName("background"));
		this.audio.Stop(this.resid.ScopedResourceName("final"));
		this.audio.Play(this.resid.ScopedResourceName("backgroundend"));
		this.OnBonusFinished();
		//this.transition.Start();
		this.robotPlay.BonusConfirmAccepted();
		this.VoicePlay = true;
		//this.plusOneAnim.Hide();
		this.screenProtocol?.Send(new BigSymbolFreegamesMessages.ResetFinalContainerWin(this.session), this.screenProtocolScope);
	}

	/**
	 *	External messages
	**/
	public OnBonusPickElement(pickElement: BonusPickElement): void {
		throw "Not implemented"
	}

	public OnBonusPickReveal(pickReveal: BonusPickReveal): void {
		throw "Not implemented"
	}

	public OnBonusRevealRemaining(revealRemaining: BonusRevealRemaining): void {
		throw "Not implemented"
	}

	public OnSimpleSpinRunResult(): void {

		this.spinIndexData++;

		let bonusRunResult = this.simpleBonusSpinResult

		
		let targets: SpinTargetParams[] = [];

		for (let i = 0; i < bonusRunResult[this.spinIndexData].SpinWithFeatures.ReelStops.length; i++) {
			// anticipation can't be on the first reel
			let t: SpinTargetParams = {
                position: bonusRunResult[this.spinIndexData].SpinWithFeatures.ReelStops[i],
                anticipation:false ,
                firstAnticipationReelIndex : -1
            };
            
			targets.push(t);
		}

		this.spinAnimation2.SetTargets([]);
		this.reelSetMapper2.SetTargets(targets);

		let scatterData =bonusRunResult[this.spinIndexData].SpinWithFeatures.FeatureResults["ScatterRandomAward"] as unknown as ScatterRandomAwardResults;
		if(scatterData){		
			this.scatterRandomAwardFeature?.SetAwards(scatterData.ScattersPositionThisSpin);
		}
		
		if(bonusRunResult[this.spinIndexData].Triggers.find(b=> b.WillTrigger == true)){
			let bonusName = Bonus.BigSymbolSpinAndHold;
			// Log.Debug(this.logGroup, `Recovering Bonus ${bonusName}`);
			this.currentBonus = this.bonusList.get(bonusName);			
		}else {
			this.currentBonus = null;
		}

		this.params.clientState.SetWin(bonusRunResult[this.spinIndexData].WinSinceGameStart.TotalWin.InCents, "BigSymbolFreegames run result");		
		this.session.TotalWin = this.params.clientState.Win;
		
	}

	public OnBonusRunResult(): void {}

	public OnBonusTotalResult(totalResult: BonusTotalResult): void {
		// Log.Debug(this.logGroup, "OnBonusTotalResult()", totalResult);
	}

	public OnBonusFinish(bonusFinish: BonusFinish): void {
		// Log.Debug(this.logGroup, "OnBonusFinish()", bonusFinish);
	}

	protected bet: SlotGameBet = null;
	protected startConfig: BigSymbolFreegamesSpinAction [] = null;
	protected simpleBonusSpinResult: BigSymbolFreegamesSpinAction [] = null;
	protected simpleAllBonusSpinResult: ISimpleBonusAction [] = null;
	protected simpleNextBonusSpinResult: BigSymbolFreegamesSpinAction [] = null;
	public Prepare(bonusStartConfig: IBonusStartConfig): void {
		// Log.Debug(this.logGroup, "Prepare() startConfig: ", startConfig);

		this.simpleAllBonusSpinResult = bonusStartConfig.actions;
		this.startConfig = bonusStartConfig.actions as BigSymbolFreegamesSpinAction [];
		this.simpleBonusSpinResult = (bonusStartConfig.actions as BigSymbolFreegamesSpinAction []).filter(b => b.Bonus == "BigSymbolFreegames");
		console.log("ApiResultBigFG:",bonusStartConfig.actions);
		this.bet = bonusStartConfig.bet;
		this.scatterRandomAwardFeature.UpdateBet(this.bet);
		this.scatterRandomAwardFeature.Start();
		this.params.clientState.SetWin(this.startConfig.find(b=>b.Phase == "Start").WinSinceGameStart.TotalWin.InCents, "BigSymbolFreegames start  result");		
		//this.scatterRandomAwardFeature.SetAwards(this.startConfig.StartingState.FeatureResults.ScatterRandomAward);

		// reset targets
		//ITs not using 
		//Fix jorge 
		// let targets: SpinTargetParams[] = this.startConfig.ReelStops.map(stop => ({
        //     position: stop,
        //     anticipation: false,
        //     firstAnticipationReelIndex: -1,
        // })); //new SpinTargetParams(stop, false));
		//this.reelSetMapper2.SetTargets(targets, true);

		// redraw reel to apply scatter values
		for (let reelIndex = 0; reelIndex < this.currentSymbols.length; reelIndex++)
		{
			for (let rowIndex = 0; rowIndex < this.currentSymbols[reelIndex].length; rowIndex++)
			{
				this.DrawSymbol(reelIndex, rowIndex);
			}
		}

		//this.holdingFeature.Start(this.startConfig.StartingState.FeatureResults.ScatterRandomAward);

		// THIS also resets the list from previious bonus
		// saves fresh positions on start
        //this.scatterPositions = this.startConfig.StartingState.FeatureResults.ScatterRandomAward.ScattersPosition;

        // check, might not have any scatter positions
        // this.scatterPositions = 
		//     this.startConfig.StartingState && 
		//     this.startConfig.StartingState.FeatureResults &&
		//     this.startConfig.StartingState.FeatureResults.ScatterRandomAward &&
		//     this.startConfig.StartingState.FeatureResults.ScatterRandomAward.ScattersPosition || [];
	}



	public HistoryView( actionIndex: number, gameState: SimpleSlotGameState): HTMLElement {

		let PayTableDivSize: Size = new Size(78.59, 76);
		// this.Paytablecells = new Size(5,6);
		// this.fontSizePaytableLine=8;



		let bonusView: HTMLElement = CreateElement("div", {
			classes: ["bonusView", "BigSymbolFreegameHistory"],
			style:
			{
				//width:"100%",
				height: Scale.Hpx(975),
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				flexDirection: "column",
			}
		});




		//let action: IBigSymbolFreegamesBonus = entry.Actions[actionIndex] as IBigSymbolFreegamesBonus;

		//let gameState: SimpleSlotGameState = JSON.parse(entry2.HistoryGameState.GameState);

		let action: BigSymbolFreegamesSpinAction = gameState.Actions[actionIndex] as BigSymbolFreegamesSpinAction;



			 if (action.Phase == "Start") {
				CreateElement("div",{
					style: 
					{
						textAlign:"center",
						lineHeight: Scale.fhpx(50),
						fontSize: Scale.fhpx(50),
						width: "100%",
						height: "100%",
						color: "white",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					},
					innerHTML: `FREE GAME START, ${action.SpinsStarted} SPINS AWARDED!`, 
					parentToAppend: bonusView,			
				});

		// 	let gameView: HTMLElement = CreateElement("div", {
		// 		classes: ["gameBackground"], parentToAppend: bonusView,
		// 		style:
		// 		{
		// 			width: Scale.Wpx(900),
		// 			height: Scale.Hpx(700),
		// 			backgroundRepeat: "no-repeat",
		// 			backgroundSize: "cover",
		// 			backgroundPosition: "center",
		// 			display: "flex",
		// 			flexDirection: "row",
		// 			justifyContent: "center",
		// 			alignItems: "center",
		// 			fontSize: Scale.fhpx(100),
		// 			color: "white",
		// 			backgroundImage: this.gameBackground.CssBackground(),
		// 		}
		// 	});

		// 	let pickedFreeGames = CreateElement("div", {
		// 		classes: ["pickedFreeGames"], parentToAppend: gameView,
		// 		style:
		// 		{
		// 			width: Scale.Wpx(300),
		// 			height: Scale.Hpx(300),
		// 			display: "flex",
		// 			justifyContent: "center",
		// 			alignItems: "center",
		// 		}
		// 	});



		// 	let symbol = this.params.symbolSpriteAnimsByName.get("FG");

		// 	let canvas: MyCanvas = new MyCanvas(new Size(Scale.H(350), Scale.W(350)));
		// 	symbol.Draw(canvas);

		// 	// let pickCanvas: MyCanvas = new MyCanvas(new Size(Scale.H(300),Scale.W(300)));
		// 	// let pickSprite: CanvasSprite = this.canvasSprite;
		// 	// pickCanvas.DrawImage(pickSprite.sprite.IdleFrame, pickSprite.sprite.IdleFrameRect,  pickCanvas.rect)

		// 	pickedFreeGames.appendChild(canvas.View());

		// 	let awarderFreeGames: HTMLElement = CreateElement("div", {
		// 		classes: ["awarderFreeGames"], parentToAppend: pickedFreeGames, innerHTML: "" + action.SpinsStarted,
		// 		style:
		// 		{
		// 			position: "absolute",
		// 			display: "flex",
		// 			justifyContent: "center",
		// 			alignItems: "center",
		// 			fontSize: Scale.fhpx(100),
		// 			color: "white",
		// 		}
		// 	});

			return bonusView;

		}
		else if (action.Phase == "Spin") {

			let lineWinsCount: number = action.Win.ResultLines.length;
			let lines: LineWin[] = action.Win.ResultLines;
			//let leftSideLines: number = lineWinsCount / 2;
			//let rightSideLines: number = lineWinsCount / 2;



			// // left side lines display
			// {
			// 	let linesLeft: HTMLElement = CreateElement("div", {
			// 		classes: ["linesLeft", this.resid.Add("History").Scope()], parentToAppend: bonusView,
			// 		style:
			// 		{
			// 			width: Scale.Wpx(131),
			// 			height: "100%",
			// 			display: "flex",
			// 			flexDirection: "column",
			// 			justifyContent: "center",
			// 		}
			// 	});

			// 	for (let i = 0; i < leftSideLines; i++) {
			// 		let line = CreateElement("div", {
			// 			classes: ["line", "" + i], parentToAppend: linesLeft,
			// 			style:
			// 			{
			// 				width: Scale.Wpx(131),
			// 				//marginBottom: Scale.Ypx(5),
			// 				display: "flex",
			// 				flexDirection: "row",


			// 			}
			// 		});

			// 		let lineLayout: HTMLElement = CreateElement("div", {
			// 			classes: ["lineLayout"], parentToAppend: line, innerHTML: this.params.slotGame.CreatePlayLines([this.params.slotGameInitData.Playlines[lines[i].LineIndex]], this.params.windowSymbolSize, lines[i].LineIndex, PayTableDivSize,true),
			// 			style:
			// 			{
			// 				display: "flex",
			// 				justifyContent: "center",
			// 				width: Scale.Hpx(78.59),
			// 			}
			// 		});
			// 		let lineStats = CreateElement("div", {
			// 			classes: ["lineStats"], parentToAppend: line, innerHTML: "" + lines[i].SymbolCount + " X " + lines[i].SymbolID + " " + this.moneyFormatter.FormatCurrency(lines[i].Win),
			// 			style:
			// 			{
			// 				fontSize: Scale.Ypx(10),
			// 				//lineHeight: Scale.fhpx(12),
			// 				color: "white",
			// 				textAlign: "center",
			// 				width: Scale.Wpx(30),
			// 				display: "flex",
			// 				justifyContent: "flex-start",
			// 			}
			// 		});
			// 	}
			// }


			let reelView: HTMLElement = null;
			//reel view
			{
				let gameView: HTMLElement = CreateElement("div", {
					classes: ["gameBackground"], parentToAppend: bonusView,
					style:
					{
						width: Scale.Wpx(700),
						height: Scale.Hpx(700),
						backgroundRepeat: "no-repeat",
						backgroundSize: "cover",
						backgroundPosition: "center",
						display: "flex",
						flexDirection: "row",
						justifyContent: "center",
						alignItems: "center",
						backgroundImage: this.gameBackground.CssBackground(),
					}
				});

				// reel view
				reelView = CreateElement("div", {
					classes: ["reelView"], parentToAppend: gameView,
					style:
					{
						width: Scale.Wpx(770),
						height: Scale.Hpx(490),
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}
				});
			}

			// all lines display
			{
				let allLines2: HTMLElement = CreateElement("div", {
					classes: ["allLines2", this.resid.Add("History").Scope()], parentToAppend: bonusView,
					style:
					{
						width: "100%",
						height: Scale.Hpx(975),
						display: "flex",
						flexDirection: "row",
						justifyContent: "center",
						flexWrap: "wrap",
					}
				});

				for (let i = 0; i < gameState.Bet.Bet.Lines; i++) {
					let line = CreateElement("div", {
						classes: ["line", "" + i], parentToAppend: allLines2,
						style:
						{
							width: Scale.Wpx(131),
							//marginBottom: Scale.Ypx(5),
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							alignItems: "center",
						}
					});

					let currentWinLine = action.Win.ResultLines.find(a => a.LineIndex == i);
					let lineLayout: HTMLElement = CreateElement("div", {
						classes: ["lineLayout"], parentToAppend: line, innerHTML: this.params.slotGame.CreatePlayLines([this.params.slotGameInitData.Playlines[i]], Size.FromPlayWindow(this.params.playWindow), i, PayTableDivSize,false),
						style:
						{
							display: "flex",
							justifyContent: "center",
							width: Scale.Hpx(78.59),
							filter: currentWinLine ? "" : "brightness(50%)",
						}
					});
					let pays : string = "&nbsp";
					if(currentWinLine)
					{
						pays = "" + currentWinLine.SymbolCount + "×" + currentWinLine.SymbolID + " pays " + service.moneyFormatter.FormatCurrency(currentWinLine.Win);
					}
					let lineStats = CreateElement("div", {
						classes: ["lineStats"], parentToAppend: line, innerHTML: pays,
						style:
						{
							fontSize: Scale.fhpx(12),
							color: "white",
							textAlign: "center",
							width: "100%",
							//display: "flex",
							//justifyContent: "flex-start",
							lineHeight: Scale.fhpx(10),
							margin: Scale.fhpx(3),
						}
					});
				}
			}

			let reelTable: HTMLElement = CreateElement("table", { classes: ["reelTable"], parentToAppend: reelView, style: { width: Scale.Wpx(700), height: Scale.Hpx(500) } });
			for (let i = 0; i < this.config.PlayWindow.Height; i++) {
				let tr: HTMLElement = CreateElement("tr", { classes: ["tr"], parentToAppend: reelTable });

				for (let j = 0; j < this.config.PlayWindow.Width; j++) {
					let coulmnWidth: number = 700 / this.config.PlayWindow.Width;
					let rowHeigt: number = 500 / this.config.PlayWindow.Height;
					let reel = this.config.ReelSet.find((r) => r.Row == i && r.Col == j);
					if (reel == null) {

					}
					else {
						let td: HTMLTableDataCellElement = CreateElement("td", {
							classes: ["td"], parentToAppend: tr,
							style: {
								//border:"5px solid blue",
								width: Scale.Wpx(coulmnWidth * reel.ColSpan),
								height: Scale.Hpx(rowHeigt * reel.RowSpan)
							}
						});
						td.colSpan = reel.ColSpan;
						td.rowSpan = reel.RowSpan;

						let symbolPerReel: number = td.rowSpan / td.colSpan;
						for (let k = 0; k < symbolPerReel; k++) {
							if (symbolPerReel == 1) {
								rowHeigt = 700;
							}


							//s.innerHTML = ""+ action.ReelsBeforeFeatures[reel.Index][k];

							let s: HTMLElement = CreateElement("div", {
								classes: ["symbol"], parentToAppend: td,
								style:
								{
									width: "100%",
									height: Scale.Hpx(rowHeigt)
									// backgroundColor:"green",
									// border:"2px solid yellow",
								}
							});

							let symbol = this.params.symbolSpriteAnimsByName.get(action.SpinWithFeatures.ReelRowExpectedSymbols[reel.Index][action.SpinWithFeatures.ReelRowExpectedSymbols[reel.Index].length - k - 1]);
							let canvas: MyCanvas = new MyCanvas(new Size(Scale.W(coulmnWidth * reel.ColSpan), Scale.H(rowHeigt)));

							symbol.Draw(canvas);

							s.appendChild(canvas.View());



							let scatterRandomAwardResult: ScatterRandomAwardResult = (action.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult)



							if (scatterRandomAwardResult != null) {

								let AwardOptionPosition = scatterRandomAwardResult.ScattersPosition as AwardOptionPosition[];
								//console.log(`Checking col ${j} row ${i}: `, scatterRandomAwardResult);
								

								let ScatterPosition = AwardOptionPosition.find(s => reel.Index == s.Col && k == s.Row);
								if (ScatterPosition != null) {

									this.scatterRandomAwardFeature?.GetHistoryValueCanvas({
										bet: gameState.Bet.Bet,
										scatterPosition: ScatterPosition,
										parentElement: canvas
									});
								}
							}
						}
					}
				}
			}
			return bonusView;
		}
		else if (action.Phase == "End") {
			let gameView: HTMLElement = CreateElement("div", {
				classes: ["gameBackground"], parentToAppend: bonusView,
				style:
				{
					width: Scale.Wpx(900),
					height: Scale.Hpx(700),
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "center",
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					alignItems: "center",
					fontSize: Scale.fhpx(100),
					color: "white",
					backgroundImage: this.gameBackground.CssBackground(),
				}
			});

			let endAction = gameState.Actions[actionIndex] as BigSymbolSpinAndHoldEndAction;
			gameView.style.flexDirection = "column";
			let titleBonusWin: HTMLElement = CreateElement("div", {
				classes: ["titleBonusWin"], parentToAppend: gameView,
				style:
				{
					width: "100%",
					height: Scale.Hpx(300),
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "center",
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					alignItems: "center",
					fontSize: Scale.fhpx(100),
					color: "white",
					textShadow: `${Scale.XY(10)}px ${Scale.XY(10)}px ${Scale.XY(10)}px black, 0px 0px ${Scale.XY(20)}px black, 0px 0px ${Scale.XY(30)}px black`,

				}
			});
			titleBonusWin.innerText = " Bonus Win";

			let winView: HTMLElement = CreateElement("div", {
				classes: ["winView"], parentToAppend: gameView,
				style:
				{
					width: "80%",
					height: Scale.Hpx(180),
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "center",
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					alignItems: "center",
					backgroundColor: "rgba(0,0,0,0.5)",
					fontSize: Scale.fhpx(100),
					color: "white",
					textShadow: `0px 0px ${Scale.XY(10)}px black, 0px 0px ${Scale.XY(20)}px black, 0px 0px ${Scale.XY(30)}px black`,
					borderWidth: Scale.XYpx(5),
					borderStyle: "solid",
					filter: `blur(${Scale.XYpx(2)})`,
					backgroundImage: "linear-gradient(rgb(0, 0, 0), rgb(22, 22, 206),rgb(0, 0, 0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
				}
			});
			winView.innerText = service.moneyFormatter.FormatCurrency(endAction.WinSinceGameStart.TotalWin.InCents)



			return bonusView;
		}
		return null;
	}
	

	public HistoryStats( actionIndex: number,  entry2?:HistoryGame): HTMLElement 
	{

		let actionStats: HTMLElement = CreateElement("div", {
			style:
			{
				width:"100%",
				height:"100%",
			}
		});
		
		//let action: IBigSymbolFreegamesBonus = entry.Actions[actionIndex] as IBigSymbolFreegamesBonus;

		let gameState : SimpleSlotGameState = JSON.parse(entry2.HistoryGameState.GameState); 
		let action: BigSymbolFreegamesSpinAction = gameState.Actions[actionIndex] as BigSymbolFreegamesSpinAction;

		let lineWins: number = action.Win.ResultLines.length;
		let runsStarted = CreateElement("div", {classes:["runsStarted"], innerHTML: "Runs Started: " + action.SpinsStarted, parentToAppend:actionStats });
		let runsPlayed = CreateElement("div", {classes:["runsPlayed"], innerHTML: "Runs Played: " + action.SpinsPlayed, parentToAppend:actionStats });
		let runsRemaining = CreateElement("div", {classes:["runsRemaining"], innerHTML: "Runs Remaining: " + action.SpinsRemaining, parentToAppend:actionStats });
		let gameLineWins = CreateElement("div", {classes:["gameLineWins"], innerHTML:"# Wining lines: "+ lineWins , parentToAppend:actionStats });
		let runWin = CreateElement("div", {classes:["runWin"], innerHTML:"Current run win: "+ service.moneyFormatter.FormatCurrency(action.WinSinceGameStart.TotalWin.InCents), parentToAppend:actionStats });
		let winUpToNow = CreateElement("div", {classes:["winUpToNow"], innerHTML:"Total bonus win: "+ service.moneyFormatter.FormatCurrency(action.WinSinceGameStart.TotalWin.InCents), parentToAppend:actionStats });
		let BonusTriggered = CreateElement("div",{classes:["bonusTriggered"], innerHTML:"Bonus: "+ action.Triggers, parentToAppend:actionStats});

		return actionStats;
	}

	public HistoryStats2( actionIndex: number, gameState: SimpleSlotGameState): ActionStats {
		let action: BigSymbolFreegamesSpinAction = gameState.Actions[actionIndex] as BigSymbolFreegamesSpinAction;

		if (action.Phase == "Start" || action.Phase == "Spin") {
			return {
				Bonus : action.Bonus,
				Action : action.Bonus,
				Stats : [							
					{ key: "Runs started", value: service.moneyFormatter.FormatQuantity(action.SpinsStarted) },
					{ key: "Runs played", value: service.moneyFormatter.FormatQuantity(action.SpinsPlayed) },
					{ key: "Runs remaining", value: service.moneyFormatter.FormatQuantity(action.SpinsRemaining) },
					{ key: "Current run win", value: service.moneyFormatter.FormatCurrency(action.WinAmounts.TotalWin.InCents) },
					{ key: "Total bonus win", value: service.moneyFormatter.FormatCurrency(action.WinSinceGameStart.TotalWin.InCents) },
				]
			}
		}
		else if(action.Phase == "End"){
			let action: BigSymbolFreegamesEndAction = gameState.Actions[actionIndex] as BigSymbolFreegamesEndAction;
			return {
				Bonus : action.Bonus,
				Action : action.Bonus,
				Stats : [
					{ key: "Bonus win", value: service.moneyFormatter.FormatCurrency(action.WinSinceBonusStart.TotalWin.InCents) },
					{ key: "Total win", value: service.moneyFormatter.FormatCurrency(action.WinSinceGameStart.TotalWin.InCents) },
				]
			}
		}
		return null;

	}

	public PixiCanvasCrash(): void {};
	//public DestroyPixi(): void {};	
	public ReCreatePixiReels(){};

	public GameSelected()
	{
		//this.spinnableReels2.Create();
	}

	public GameExit()
	{
		//this.spinnableReels2.Destroy();
	}
}
